import { useEffect, useState } from "react";
import {
  CLIENT_COLORS, CYCLE, CR_COLORS, PRI_DOT,
  TASK_STATUS_COLORS, TASK_TYPES, TASK_STATUSES, PRIORITIES,
  TIPOS_ANALISE, ANALISE_TIPO_STYLE,
} from "../constants";

const OTIM_STATUS_STYLE = {
  "Em andamento": { bg: "var(--info-soft)",       color: "var(--info-ink)" },
  "Testado":      { bg: "var(--cat-orange-soft)", color: "var(--cat-orange-ink)" },
  "Validado":     { bg: "var(--success-soft)",    color: "var(--success-ink)" },
  "Descartado":   { bg: "var(--surface-3)",       color: "var(--muted)" },
};
const OTIM_STATUSES   = ["Em andamento", "Testado", "Validado", "Descartado"];
const OTIM_PLATAFORMAS = ["Meta Ads", "Google Ads", "Landing Page", "Instagram", "Criativo", "Copy", "Público", "Orçamento", "Outro"];
const ANOTACAO_TIPOS  = ["Reunião", "Nota", "Feedback", "Decisão"];

// Kit 2026: situação vira selo com tom (ok | warn | bad | info | off | gold)
const TASK_TONE = { "A fazer": "off", "Em andamento": "info", "Aguardando terceiro": "warn", "Concluído": "ok" };
const OTIM_TONE = { "Em andamento": "info", "Testado": "warn", "Validado": "ok", "Descartado": "off" };
const IMPACTO_TONE = { Alto: "bad", Médio: "warn", Baixo: "off" };
const PRI_TONE = { Alta: "bad", Média: "warn", Baixa: "off" };
const hoje = () => new Date().toISOString().split("T")[0];
const resumo = (t, n = 90) => (t && t.length > n ? t.slice(0, n).trim() + "…" : t || "");
import { uid, isoToday, curMonth, nextMonthStr, fmtDate, fmtMes, fmtCurr, fmtNum, buildChecklist, buildOnboardingChecklist, getCurrentWeek } from "../utils";
import { db, gerarCopy, gerarRelatorio, gerarSocialPosts } from "../db";
import {
  Tag, Dot, Spinner, Btn, Modal, Field, Inp, Sel, Txta,
  ProgressBar, Empty, Card, FormRow,
  Stage, StageTabs, KpiStrip, Explica, Selo,
  BlockHead, ExpandTable, Chips, MiniBar, Check, Detalhe,
} from "../components/primitives";
import { PlanoTab } from "../components/PlanoTab";
import { MetaAdsTab } from "../components/MetaAdsTab";

// ── CycleBar ──────────────────────────────────────────────────────────────────
function CycleBar({ stage, onChange }) {
  const current = CYCLE.findIndex((s) => s.id === stage);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 0, padding: "14px 0 0" }}>
      {CYCLE.map((s, i) => {
        const isActive  = s.id === stage;
        const isPast    = i < current;
        const isNext    = i > current;
        return (
          <div
            key={s.id}
            onClick={() => onChange(s.id)}
            style={{ display: "flex", alignItems: "center", cursor: "pointer", flex: 1 }}
          >
            <div style={{
              display: "flex", flexDirection: "column", alignItems: "center",
              flex: 1, position: "relative",
            }}>
              {i > 0 && (
                <div style={{
                  position: "absolute", left: 0, right: "50%", top: 11, height: 2,
                  background: isPast || isActive ? "var(--primary)" : "var(--line-soft)",
                }} />
              )}
              <div style={{
                width: 22, height: 22, borderRadius: "50%", zIndex: 1,
                background: isActive ? "var(--primary)" : isPast ? "var(--primary-soft)" : "var(--line-soft)",
                border: `2px solid ${isActive ? "var(--primary)" : isPast ? "var(--primary)" : "var(--line)"}`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 10, fontWeight: 700,
                color: isActive ? "#fff" : isPast ? "var(--primary)" : "var(--faint)",
                transition: "all .2s",
                flexShrink: 0,
              }}>
                {isPast ? "✓" : s.s}
              </div>
              {i < CYCLE.length - 1 && (
                <div style={{
                  position: "absolute", left: "50%", right: 0, top: 11, height: 2,
                  background: isPast ? "var(--primary)" : "var(--line-soft)",
                }} />
              )}
              <div style={{
                fontSize: 10, fontWeight: isActive ? 700 : 400,
                color: isActive ? "var(--primary)" : isPast ? "var(--primary)" : "var(--faint)",
                marginTop: 5, whiteSpace: "nowrap", textAlign: "center",
              }}>
                {s.l}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ── HoverInfo — popup "o que é / por que fazer" ───────────────────────────────
export function HoverInfo({ oque, porque, children }) {
  const [show, setShow] = useState(false);
  if (!oque && !porque) return children;
  return (
    <span
      style={{ position: "relative", display: "inline-flex", alignItems: "center", gap: 6, flex: 1, minWidth: 0 }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      <span style={{
        fontSize: 10, color: "var(--faint)", border: "1px solid var(--line)",
        borderRadius: "50%", width: 14, height: 14, flexShrink: 0,
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        fontWeight: 700, cursor: "help",
      }}>i</span>
      {show && (
        <span style={{
          position: "absolute", left: 0, top: "calc(100% + 6px)", zIndex: 50,
          width: 320, maxWidth: "80vw", padding: "12px 14px",
          background: "var(--ink)", color: "var(--primary-fg)",
          borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,.25)",
          fontSize: 12, lineHeight: 1.55, whiteSpace: "normal",
          pointerEvents: "none", display: "block", textAlign: "left",
        }}>
          {oque && (
            <span style={{ display: "block", marginBottom: porque ? 8 : 0 }}>
              <span style={{ display: "block", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".06em", opacity: .65, marginBottom: 2 }}>O que é</span>
              {oque}
            </span>
          )}
          {porque && (
            <span style={{ display: "block" }}>
              <span style={{ display: "block", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".06em", opacity: .65, marginBottom: 2 }}>Por que fazer</span>
              {porque}
            </span>
          )}
        </span>
      )}
    </span>
  );
}

// ── CheckItem ─────────────────────────────────────────────────────────────────
function CheckItem({ item, onToggle }) {
  const [expanded, setExpanded] = useState(false);
  const log     = item.completed_log || [];
  const lastLog = log.length > 0 ? log[log.length - 1] : null;

  return (
    <div style={{ borderRadius: 8, marginBottom: 2 }}>
      <div
        style={{
          display: "flex", alignItems: "center", gap: 10,
          padding: "6px 4px", cursor: "pointer",
        }}
      >
        <Check on={item.done} onClick={() => onToggle(item.id)} label={item.text} />

        <HoverInfo oque={item.oque} porque={item.porque}>
          <span
            onClick={() => onToggle(item.id)}
            style={{
              fontSize: 13, flex: 1,
              color: item.done ? "var(--faint)" : "var(--ink)",
              textDecoration: item.done ? "line-through" : "none",
            }}
          >
            {item.text}
          </span>
        </HoverInfo>

        {lastLog && (
          <span style={{ fontSize: 10, color: "var(--faint)", flexShrink: 0, whiteSpace: "nowrap" }}>
            ↩ {fmtDate(lastLog.date)}
          </span>
        )}

        {log.length > 0 && (
          <button
            onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v); }}
            style={{
              background: "none", border: "none", cursor: "pointer",
              fontSize: 9, color: "var(--faint)", padding: "0 2px", flexShrink: 0,
            }}
          >
            {expanded ? "▲" : "▼"}
          </button>
        )}
      </div>

      {expanded && log.length > 0 && (
        <div style={{
          marginLeft: 26, marginBottom: 6,
          background: "var(--bg)", borderRadius: 6,
          padding: "8px 10px",
          display: "flex", flexDirection: "column", gap: 4,
        }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 4 }}>
            Histórico de execução
          </div>
          {[...log].reverse().map((entry, i) => (
            <div key={i} style={{ display: "flex", gap: 10, fontSize: 11, alignItems: "center" }}>
              <span style={{ color: "var(--success)", fontWeight: 700 }}>✓</span>
              <span style={{ color: "var(--ink)", fontWeight: 500 }}>{fmtDate(entry.date)}</span>
              {entry.semana && (
                <span style={{
                  background: "var(--primary-soft)", color: "var(--primary)",
                  borderRadius: "var(--r-pill)", padding: "1px 7px",
                  fontSize: 10, fontWeight: 600,
                }}>
                  {entry.semana}
                </span>
              )}
              {entry.feito_por && (
                <span style={{ color: "var(--muted)" }}>por {entry.feito_por}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── TaskModal ─────────────────────────────────────────────────────────────────
function TaskModal({ task, client, onClose, onUpdate, onDelete, planos, onUpdatePlano }) {
  const [t, setT]           = useState(task);
  const [saving, setSaving] = useState(false);
  const [showOtim, setShowOtim] = useState(false);
  const [otim, setOtim]     = useState({ action: "", reason: "", expected: "", notes: "" });
  const [feitoPor, setFeitoPor] = useState(
    () => localStorage.getItem("rc2_feito_por") || "Rafael"
  );

  const groups  = [...new Set((t.checklist || []).map((i) => i.group))].filter(Boolean);
  const noGroup = (t.checklist || []).filter((i) => !i.group);

  async function toggleItem(id) {
    const semana = getCurrentWeek();
    const today  = isoToday();
    const month  = curMonth();
    const checklist = t.checklist.map((i) => {
      if (i.id !== id) return i;
      const nowDone   = !i.done;
      const prevLog   = i.completed_log || [];
      const newLog    = nowDone
        ? [...prevLog, { date: today, semana, feito_por: feitoPor || "Rafael" }]
        : prevLog;
      return { ...i, done: nowDone, completed_log: newLog };
    });
    setT({ ...t, checklist });
    setSaving(true);
    await onUpdate(t.id, { checklist });

    // Sync AC → Plano: item marcado como feito valida o item equivalente no plano mensal
    const changed = checklist.find((i) => i.id === id);
    if (changed?.done && planos && onUpdatePlano) {
      const planoAtual = planos.find((p) => p.month === month);
      if (planoAtual) {
        let synced = false;
        const updatedItems = planoAtual.items.map((pi) => {
          if (!pi.done && pi.group === changed.group && pi.text === changed.text) {
            synced = true;
            return { ...pi, done: true };
          }
          return pi;
        });
        if (synced) await onUpdatePlano(planoAtual.id, { items: updatedItems });
      }
    }

    setSaving(false);
  }

  function saveFeitoPor(v) {
    setFeitoPor(v);
    localStorage.setItem("rc2_feito_por", v);
  }

  async function saveStatus(status) {
    setT({ ...t, status });
    await onUpdate(t.id, { status });
  }

  async function addOtimizacao() {
    if (!otim.action.trim()) return;
    const entry = { id: uid(), date: isoToday(), ...otim };
    const history = [...(t.history || []), entry];
    setT({ ...t, history });
    await onUpdate(t.id, { history });
    setOtim({ action: "", reason: "", expected: "", notes: "" });
    setShowOtim(false);
  }

  const done  = (t.checklist || []).filter((x) => x.done).length;
  const total = (t.checklist || []).length;

  return (
    <Modal
      title={t.name}
      subtitle={`${client.name} · ${t.type} · ${t.month || curMonth()}`}
      onClose={onClose}
      width={600}
    >
      <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap", alignItems: "center" }}>
        <Chips label="Situação da tarefa" active={t.status}
          items={TASK_STATUSES.map((s) => ({ id: s, label: s }))}
          onChange={saveStatus} />
        {saving && <Spinner size={16} />}
      </div>

      {total > 0 && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
            <span className="eyebrow">Checklist</span>
            <MiniBar done={done} total={total} width={120} />
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ fontSize: 11, color: "var(--faint)" }}>feito por</span>
              <input
                value={feitoPor}
                onChange={(e) => saveFeitoPor(e.target.value)}
                style={{
                  fontSize: 11, padding: "2px 8px", borderRadius: "var(--r-pill)",
                  border: "1px solid var(--line)", background: "var(--surface)",
                  color: "var(--ink)", width: 90, fontFamily: "inherit",
                }}
              />
            </div>
          </div>
          {noGroup.map((item) => (
            <CheckItem key={item.id} item={item} onToggle={toggleItem} />
          ))}
          {groups.map((g) => (
            <div key={g} style={{ marginBottom: 14 }}>
              <div style={{
                fontSize: 11, fontWeight: 700, color: "var(--muted)",
                textTransform: "uppercase", letterSpacing: ".06em",
                padding: "6px 0 6px", borderBottom: `1px solid ${"var(--line-soft)"}`, marginBottom: 6,
              }}>
                {g}
              </div>
              {(t.checklist || []).filter((i) => i.group === g).map((item) => (
                <CheckItem key={item.id} item={item} onToggle={toggleItem} />
              ))}
            </div>
          ))}
        </div>
      )}

      <div style={{ borderTop: `1px solid ${"var(--line-soft)"}`, paddingTop: 16, marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
          <span className="eyebrow">Otimizações ({(t.history || []).length})</span>
          <Btn sm variant="secondary" onClick={() => setShowOtim(!showOtim)}>+ Registrar</Btn>
        </div>

        {showOtim && (
          <Card style={{ padding: "14px 16px", marginBottom: 12, background: "var(--bg)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <Field label="O que foi feito"><Txta rows={2} value={otim.action} onChange={(e) => setOtim({ ...otim, action: e.target.value })} placeholder="Descreva a ação..." /></Field>
              <FormRow>
                <Field label="Motivo" half><Inp value={otim.reason} onChange={(e) => setOtim({ ...otim, reason: e.target.value })} /></Field>
                <Field label="Resultado esperado" half><Inp value={otim.expected} onChange={(e) => setOtim({ ...otim, expected: e.target.value })} /></Field>
              </FormRow>
              <Field label="Observações"><Inp value={otim.notes} onChange={(e) => setOtim({ ...otim, notes: e.target.value })} /></Field>
              <Btn variant="accent" sm onClick={addOtimizacao}>Salvar otimização</Btn>
            </div>
          </Card>
        )}

        {(t.history || []).length === 0 && !showOtim && (
          <div style={{ fontSize: 12, color: "var(--faint)" }}>Nenhuma otimização registrada.</div>
        )}

        {[...(t.history || [])].reverse().map((h) => (
          <div key={h.id} style={{ borderLeft: `2px solid ${"var(--primary)"}`, paddingLeft: 12, marginBottom: 10 }}>
            <div style={{ fontSize: 12, color: "var(--faint)", marginBottom: 2 }}>{fmtDate(h.date)}</div>
            <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)", marginBottom: 3 }}>{h.action}</div>
            {h.reason   && <div style={{ fontSize: 12, color: "var(--muted)" }}>Motivo: {h.reason}</div>}
            {h.expected && <div style={{ fontSize: 12, color: "var(--muted)" }}>Esperado: {h.expected}</div>}
            {h.notes    && <div style={{ fontSize: 12, color: "var(--faint)" }}>Obs: {h.notes}</div>}
          </div>
        ))}
      </div>

      <div style={{ borderTop: `1px solid var(--line-soft)`, paddingTop: 16, marginBottom: 16 }}>
        <div className="eyebrow" style={{ marginBottom: 8 }}>Observações</div>
        <textarea
          value={t.notas || ""}
          onChange={async (e) => {
            const notas = e.target.value;
            setT({ ...t, notas });
            await onUpdate(t.id, { notas });
          }}
          placeholder="Ações realizadas que não constam no checklist, contexto da semana, decisões tomadas..."
          style={{
            width: "100%", minHeight: 80, resize: "vertical",
            fontSize: 13, color: "var(--ink)", lineHeight: 1.6,
            background: "var(--bg)", border: "1px solid var(--line)",
            borderRadius: 8, padding: "10px 12px",
            fontFamily: "inherit", boxSizing: "border-box",
          }}
        />
      </div>

      <div style={{ display: "flex", gap: 8, borderTop: `1px solid ${"var(--line-soft)"}`, paddingTop: 14 }}>
        <Btn variant="danger" sm onClick={() => { if (window.confirm("Excluir tarefa?")) onDelete(t.id); }}>
          Excluir
        </Btn>
        <div style={{ flex: 1 }} />
        <Btn variant="secondary" sm onClick={onClose}>Fechar</Btn>
      </div>
    </Modal>
  );
}

// ── OperacaoTab ───────────────────────────────────────────────────────────────
function OperacaoTab({ client, tasks, onNewTask, onUpdateTask, onDeleteTask, planos, onUpdatePlano }) {
  const [selectedTask, setSelectedTask] = useState(null);
  const [showNewTask, setShowNewTask]   = useState(false);
  const [newType, setNewType]           = useState("AC");
  const [newPriority, setNewPriority]   = useState("Alta");
  const [newDueDate, setNewDueDate]     = useState("");
  const [newResponsavel, setNewResponsavel] = useState("");
  const [onbCenario, setOnbCenario]     = useState("zero");

  async function handleNewTask() {
    let checklist = [];
    if (newType === "AC" || newType === "AT")   checklist = buildChecklist(client.notes || "");
    else if (newType === "Onboarding")          checklist = buildOnboardingChecklist(onbCenario);
    const task = await onNewTask({
      client_id:   client.id,
      name:        `${newType} — ${curMonth()}`,
      type:        newType,
      priority:    newPriority,
      status:      "A fazer",
      cycle_stage: client.cycle_stage,
      month:       curMonth(),
      checklist,
      history:     [],
      archived:    false,
      due_date:    newDueDate || null,
      responsavel: newResponsavel || null,
    });
    if (task) setSelectedTask(Array.isArray(task) ? task[0] : task);
    setShowNewTask(false);
    setNewDueDate("");
    setNewResponsavel("");
    setNewPriority("Alta");
  }

  return (
    <div className="tab-pane">
      <BlockHead title={`Tarefas de ${curMonth()}`} sub="Uma linha por tarefa. Clique para abrir o checklist.">
        <Btn sm variant="primary" onClick={() => { setNewType("AC"); setShowNewTask(true); }}>+ Nova tarefa</Btn>
      </BlockHead>

      <ExpandTable
        minWidth={620}
        rows={tasks}
        empty="Nenhuma tarefa este mês. Crie uma AC para começar."
        onOpen={(t) => setSelectedTask(t)}
        columns={[
          { key: "name", label: "Tarefa", render: (t) => (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
              <Dot color={PRI_DOT[t.priority] || "var(--faint)"} size={8} />
              <span className="name">{t.name}</span>
            </span>
          ) },
          { key: "type", label: "Tipo", render: (t) => <span className="sub">{t.type}</span> },
          { key: "status", label: "Situação", render: (t) => <Selo tone={TASK_TONE[t.status] || "off"}>{t.status || "A fazer"}</Selo> },
          { key: "check", label: "Checklist", render: (t) => {
            const total = (t.checklist || []).length;
            return total ? <MiniBar done={(t.checklist || []).filter((x) => x.done).length} total={total} /> : <span className="sub">—</span>;
          } },
          { key: "due", label: "Prazo", render: (t) => t.due_date
            ? <span style={{ color: t.due_date < hoje() && t.status !== "Concluído" ? "var(--danger)" : "var(--muted)", fontSize: 13 }}>{fmtDate(t.due_date)}</span>
            : <span className="sub">—</span> },
          { key: "resp", label: "Responsável", render: (t) => <span className="sub">{t.responsavel || "—"}</span> },
        ]}
      />

      {showNewTask && (
        <Modal title="Nova tarefa" subtitle={`Cliente: ${client.name}`} onClose={() => setShowNewTask(false)} width={400}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <FormRow>
              <Field label="Tipo" half>
                <Sel value={newType} onChange={(e) => setNewType(e.target.value)}>
                  {TASK_TYPES.map((t) => <option key={t}>{t}</option>)}
                </Sel>
              </Field>
              <Field label="Prioridade" half>
                <Sel value={newPriority} onChange={(e) => setNewPriority(e.target.value)}>
                  {PRIORITIES.map((p) => <option key={p}>{p}</option>)}
                </Sel>
              </Field>
            </FormRow>
            <FormRow>
              <Field label="Prazo" half>
                <Inp type="date" value={newDueDate} onChange={(e) => setNewDueDate(e.target.value)} />
              </Field>
              <Field label="Responsável" half>
                <Inp value={newResponsavel} onChange={(e) => setNewResponsavel(e.target.value)} placeholder="Nome..." />
              </Field>
            </FormRow>
            {(newType === "AC" || newType === "AT") && (
              <div style={{ background: "var(--primary-soft)", borderRadius: 12, padding: "10px 14px", fontSize: 13, color: "var(--muted)" }}>
                Checklist gerado automaticamente. Plataformas: <strong>{client.notes || "não informadas"}</strong>
              </div>
            )}
            {newType === "Onboarding" && (
              <>
                <Field label="Cenário do cliente">
                  <Sel value={onbCenario} onChange={(e) => setOnbCenario(e.target.value)}>
                    <option value="zero">Nunca anunciou (conta do zero)</option>
                    <option value="migracao">Veio de gestão anterior (insatisfeito)</option>
                  </Sel>
                </Field>
                <div style={{ background: "var(--primary-soft)", borderRadius: 12, padding: "10px 14px", fontSize: 13, color: "var(--muted)", lineHeight: 1.6 }}>
                  {onbCenario === "zero"
                    ? <>Foco: <strong>expectativa</strong>. Estrutura, rastreamento e régua de resultado combinada antes da primeira campanha.</>
                    : <>Foco: <strong>confiança</strong>. Auditar antes de mexer, preservar aprendizado, linha de base documentada e vitória rápida.</>}
                </div>
              </>
            )}
            <Btn variant="accent" full onClick={handleNewTask}>Criar tarefa</Btn>
          </div>
        </Modal>
      )}

      {selectedTask && (
        <TaskModal
          task={selectedTask}
          client={client}
          onClose={() => setSelectedTask(null)}
          onUpdate={async (id, data) => {
            const updated = await onUpdateTask(id, data);
            setSelectedTask(Array.isArray(updated) ? updated[0] : { ...selectedTask, ...data });
          }}
          onDelete={async (id) => {
            await onDeleteTask(id);
            setSelectedTask(null);
          }}
          planos={planos}
          onUpdatePlano={onUpdatePlano}
        />
      )}
    </div>
  );
}

// ── HistoricoModal ────────────────────────────────────────────────────────────
function HistoricoModal({ clientId, onClose, onSave, initial }) {
  const [f, setF] = useState(initial || {
    mes: curMonth(), tipo: "AT",
    investimento: "", leads: "", cpl: "", cpa: "", roas: "", ctr: "", cpc: "",
    resumo: "", hipoteses_validadas: "", hipoteses_descartadas: "",
    gargalos: "", acoes_realizadas: "", proximos_passos: "", observacoes: "",
    imagem_url: "",
  });
  const [saving, setSaving] = useState(false);

  const up  = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const num = (v) => v === "" ? null : parseFloat(v);
  const int = (v) => v === "" ? null : parseInt(v, 10);

  async function save() {
    setSaving(true);
    await onSave({
      client_id: clientId,
      mes: f.mes, tipo: f.tipo,
      investimento: num(f.investimento), leads: int(f.leads),
      cpl: num(f.cpl), cpa: num(f.cpa), roas: num(f.roas),
      ctr: num(f.ctr), cpc: num(f.cpc),
      resumo: f.resumo || null,
      hipoteses_validadas:   f.hipoteses_validadas   || null,
      hipoteses_descartadas: f.hipoteses_descartadas || null,
      gargalos:              f.gargalos              || null,
      acoes_realizadas:      f.acoes_realizadas      || null,
      proximos_passos:       f.proximos_passos       || null,
      observacoes:           f.observacoes           || null,
      imagem_url:            f.imagem_url            || null,
    });
    setSaving(false);
  }

  return (
    <Modal title="Registro mensal" subtitle="AC, AT ou Diagnóstico" onClose={onClose} width={620}>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <FormRow>
          <Field label="Mês (MM/AAAA)" half>
            <Inp value={f.mes} onChange={(e) => up("mes", e.target.value)} placeholder="05/2026" />
          </Field>
          <Field label="Tipo" half>
            <Sel value={f.tipo} onChange={(e) => up("tipo", e.target.value)}>
              {["AC","AT","Diagnóstico","Onboarding","Relatório"].map((t) => <option key={t}>{t}</option>)}
            </Sel>
          </Field>
        </FormRow>

        <div style={{ borderTop: `1px solid ${"var(--line-soft)"}`, paddingTop: 14 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 12 }}>
            Métricas
          </div>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            {[
              { k: "investimento", l: "Investimento (R$)" },
              { k: "leads",        l: "Leads" },
              { k: "cpl",          l: "CPL (R$)" },
              { k: "cpa",          l: "CPA (R$)" },
              { k: "roas",         l: "ROAS" },
              { k: "ctr",          l: "CTR (%)" },
              { k: "cpc",          l: "CPC (R$)" },
            ].map((m) => (
              <Field key={m.k} label={m.l} third>
                <Inp
                  type="number" step="0.01"
                  value={f[m.k]}
                  onChange={(e) => up(m.k, e.target.value)}
                  placeholder="0"
                />
              </Field>
            ))}
          </div>
        </div>

        <div style={{ borderTop: `1px solid ${"var(--line-soft)"}`, paddingTop: 14 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 12 }}>
            Análise
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Field label="Resumo executivo">
              <Txta rows={3} value={f.resumo} onChange={(e) => up("resumo", e.target.value)} placeholder="O que aconteceu neste mês..." />
            </Field>
            <FormRow>
              <Field label="Hipóteses validadas" half>
                <Txta rows={2} value={f.hipoteses_validadas} onChange={(e) => up("hipoteses_validadas", e.target.value)} />
              </Field>
              <Field label="Hipóteses descartadas" half>
                <Txta rows={2} value={f.hipoteses_descartadas} onChange={(e) => up("hipoteses_descartadas", e.target.value)} />
              </Field>
            </FormRow>
            <Field label="Gargalos identificados">
              <Txta rows={2} value={f.gargalos} onChange={(e) => up("gargalos", e.target.value)} />
            </Field>
            <FormRow>
              <Field label="Ações realizadas" half>
                <Txta rows={2} value={f.acoes_realizadas} onChange={(e) => up("acoes_realizadas", e.target.value)} />
              </Field>
              <Field label="Próximos passos" half>
                <Txta rows={2} value={f.proximos_passos} onChange={(e) => up("proximos_passos", e.target.value)} />
              </Field>
            </FormRow>
            <Field label="Observações">
              <Txta rows={2} value={f.observacoes} onChange={(e) => up("observacoes", e.target.value)} />
            </Field>
            <Field label="URL da imagem (evidência)">
              <Inp value={f.imagem_url} onChange={(e) => up("imagem_url", e.target.value)} placeholder="https://..." />
            </Field>
          </div>
        </div>

        <Btn variant="accent" full onClick={save} disabled={saving}>
          {saving ? "Salvando..." : "Salvar registro"}
        </Btn>
      </div>
    </Modal>
  );
}

// ── HistoricoTab ──────────────────────────────────────────────────────────────
function HistoricoTab({ client, historico, onNewHistorico }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="tab-pane">
      <BlockHead title="Histórico de performance" sub="Um mês por linha. Clique para ver resumo, hipóteses e próximos passos.">
        <Btn sm variant="primary" onClick={() => setShowModal(true)}>+ Novo registro</Btn>
      </BlockHead>

      <ExpandTable
        minWidth={680}
        rows={historico}
        empty="Nenhum registro histórico. Adicione um para acompanhar a evolução."
        columns={[
          { key: "mes", label: "Mês", render: (h) => <span className="name">{fmtMes(h.mes)}</span> },
          { key: "tipo", label: "Tipo", render: (h) => <Selo tone="info" dot={false}>{h.tipo}</Selo> },
          { key: "inv", label: "Investimento", align: "right", render: (h) => fmtCurr(h.investimento) },
          { key: "leads", label: "Leads", align: "right", render: (h) => h.leads ?? "—" },
          { key: "cpl", label: "CPL", align: "right", render: (h) => fmtCurr(h.cpl) },
          { key: "cpa", label: "CPA", align: "right", render: (h) => fmtCurr(h.cpa) },
          { key: "roas", label: "ROAS", align: "right", render: (h) => (h.roas ? `${fmtNum(h.roas)}x` : "—") },
        ]}
        detail={(h) => (
          <div className="detail-grid">
            <dl className="facts">
              <dt>CTR</dt><dd>{h.ctr ? `${fmtNum(h.ctr)}%` : "—"}</dd>
              <dt>CPC</dt><dd>{fmtCurr(h.cpc)}</dd>
            </dl>
            <Detalhe label="Resumo">{h.resumo}</Detalhe>
            <Detalhe label="Hipóteses validadas">{h.hipoteses_validadas}</Detalhe>
            <Detalhe label="Hipóteses descartadas">{h.hipoteses_descartadas}</Detalhe>
            <Detalhe label="Gargalos">{h.gargalos}</Detalhe>
            <Detalhe label="Ações realizadas">{h.acoes_realizadas}</Detalhe>
            <Detalhe label="Próximos passos">{h.proximos_passos}</Detalhe>
          </div>
        )}
      />

      {showModal && (
        <HistoricoModal
          clientId={client.id}
          onClose={() => setShowModal(false)}
          onSave={async (data) => {
            await onNewHistorico(data);
            setShowModal(false);
          }}
        />
      )}
    </div>
  );
}

// ── TrackingTab ───────────────────────────────────────────────────────────────
const PIXELS_DEF = [
  { key: "meta",       label: "Meta Pixel",       placeholder: "1234567890123" },
  { key: "google_ads", label: "Google Ads",        placeholder: "AW-0000000000" },
  { key: "gtm",        label: "Google Tag Manager",placeholder: "GTM-XXXXXXX" },
  { key: "ga4",        label: "GA4",               placeholder: "G-XXXXXXXXXX" },
  { key: "tiktok",     label: "TikTok Pixel",      placeholder: "CXXXXXXXXXXXXXXXX" },
  { key: "linkedin",   label: "LinkedIn Insight",  placeholder: "0000000" },
];
const EVENTOS_DEF = [
  { key: "lead",         label: "Lead / Geração de lead" },
  { key: "formulario",   label: "Formulário enviado" },
  { key: "purchase",     label: "Purchase / Compra" },
  { key: "view_content", label: "View Content / PageView" },
  { key: "agendamento",  label: "Agendamento (Schedule)" },
  { key: "whatsapp",     label: "WhatsApp Click" },
  { key: "add_to_cart",  label: "Add to Cart" },
];
const CAPI_DEF = [
  { key: "meta_capi",           label: "Meta CAPI (API de Conversões)" },
  { key: "server_side_gtm",     label: "Server-side GTM" },
  { key: "event_test_approved", label: "Teste de eventos aprovado (EMQ ≥ 6)" },
];

function TrackingTab({ client, onUpdateClient }) {
  const raw = client.tracking_config || {};

  const [pixels,   setPixels]   = useState(() => {
    const saved = raw.pixels || {};
    return PIXELS_DEF.reduce((acc, p) => {
      acc[p.key] = { on: saved[p.key]?.on || false, id: saved[p.key]?.id || "" };
      return acc;
    }, {});
  });
  const [eventos,  setEventos]  = useState(() => {
    const saved = raw.eventos || {};
    return EVENTOS_DEF.reduce((acc, e) => { acc[e.key] = saved[e.key] || false; return acc; }, {});
  });
  const [capi,     setCapi]     = useState(() => {
    const saved = raw.capi || {};
    return CAPI_DEF.reduce((acc, c) => { acc[c.key] = saved[c.key] || false; return acc; }, {});
  });
  const [saving,   setSaving]   = useState(false);

  // Total de itens configuráveis
  const totalItems = PIXELS_DEF.length + EVENTOS_DEF.length + CAPI_DEF.length;
  const doneItems  =
    Object.values(pixels).filter((p) => p.on).length +
    Object.values(eventos).filter(Boolean).length +
    Object.values(capi).filter(Boolean).length;
  const pct = Math.round((doneItems / totalItems) * 100);
  const barColor = pct === 100 ? "var(--success)" : pct >= 60 ? "var(--primary)" : pct >= 30 ? "var(--warn)" : "var(--danger)";

  async function persist(newPixels, newEventos, newCapi) {
    if (!onUpdateClient) return;
    setSaving(true);
    try {
      await onUpdateClient(client.id, {
        tracking_config: { pixels: newPixels, eventos: newEventos, capi: newCapi },
      });
    } finally { setSaving(false); }
  }

  function togglePixel(key) {
    const next = { ...pixels, [key]: { ...pixels[key], on: !pixels[key].on } };
    setPixels(next);
    persist(next, eventos, capi);
  }
  function setPixelId(key, val) {
    const next = { ...pixels, [key]: { ...pixels[key], id: val } };
    setPixels(next);
  }
  function blurPixelId(key) {
    persist(pixels, eventos, capi);
  }
  function toggleEvento(key) {
    const next = { ...eventos, [key]: !eventos[key] };
    setEventos(next);
    persist(pixels, next, capi);
  }
  function toggleCapi(key) {
    const next = { ...capi, [key]: !capi[key] };
    setCapi(next);
    persist(pixels, eventos, next);
  }

  const Section = ({ title, done, total, children }) => (
    <div className="klist" style={{ marginBottom: 16 }}>
      <div className="klist-head">
        <span className="eyebrow">{title}</span>
        <MiniBar done={done} total={total} width={70} />
      </div>
      {children}
    </div>
  );

  // Uma linha por item: marcar · nome · ID (quando houver) · situação
  const Row = ({ checked, onToggle, label, id, idPlaceholder, onIdChange, onIdBlur }) => (
    <div className="klist-row" style={{ cursor: "pointer" }} onClick={onToggle}>
      <Check on={checked} onClick={onToggle} label={label} />
      <span className="txt" style={{ color: checked ? "var(--ink)" : "var(--muted)", fontWeight: checked ? 600 : 400 }}>{label}</span>
      {idPlaceholder !== undefined && (
        <input
          className="input"
          value={id}
          onChange={(e) => { e.stopPropagation(); onIdChange(e.target.value); }}
          onBlur={(e) => { e.stopPropagation(); onIdBlur(); }}
          onClick={(e) => e.stopPropagation()}
          placeholder={idPlaceholder}
          aria-label={`ID ${label}`}
          style={{ fontFamily: "var(--font-data)", fontSize: 12, width: 170, height: 32, padding: "4px 10px" }}
        />
      )}
      <Selo tone={checked ? "ok" : "off"}>{checked ? "ok" : "falta"}</Selo>
    </div>
  );

  const nPix = Object.values(pixels).filter((p) => p.on).length;
  const nEv  = Object.values(eventos).filter(Boolean).length;
  const nCapi = Object.values(capi).filter(Boolean).length;

  return (
    <div className="tab-pane" style={{ maxWidth: 760 }}>
      <BlockHead title="Rastreamento" sub="Marque o que já está instalado e conferido. Salva sozinho.">
        {saving && <span className="eyebrow">Salvando…</span>}
      </BlockHead>
      <KpiStrip style={{ marginBottom: 16 }} items={[
        { label: "Configurado", value: `${pct}%`, sub: `${doneItems}/${totalItems} itens`, tone: pct === 100 ? "ok" : pct >= 60 ? "" : "warn", color: pct < 30 ? barColor : undefined },
        { label: "Pixels", value: `${nPix}/${PIXELS_DEF.length}` },
        { label: "Eventos", value: `${nEv}/${EVENTOS_DEF.length}` },
        { label: "Servidor", value: `${nCapi}/${CAPI_DEF.length}`, sub: capi.meta_capi ? "CAPI ligada" : "sem CAPI", tone: capi.meta_capi ? "ok" : "warn" },
      ]} />

      <Section title="Pixels e tags instalados" done={nPix} total={PIXELS_DEF.length}>
        {PIXELS_DEF.map((p) => (
          <Row key={p.key}
            checked={pixels[p.key].on}
            onToggle={() => togglePixel(p.key)}
            label={p.label}
            id={pixels[p.key].id}
            idPlaceholder={p.placeholder}
            onIdChange={(v) => setPixelId(p.key, v)}
            onIdBlur={() => blurPixelId(p.key)}
          />
        ))}
      </Section>

      <Section title="Eventos de conversão configurados" done={nEv} total={EVENTOS_DEF.length}>
        {EVENTOS_DEF.map((e) => (
          <Row key={e.key}
            checked={eventos[e.key]}
            onToggle={() => toggleEvento(e.key)}
            label={e.label}
          />
        ))}
      </Section>

      <Section title="API de Conversões (servidor)" done={nCapi} total={CAPI_DEF.length}>
        {CAPI_DEF.map((c) => (
          <Row key={c.key}
            checked={capi[c.key]}
            onToggle={() => toggleCapi(c.key)}
            label={c.label}
          />
        ))}
      </Section>
    </div>
  );
}

// ── CriativoDetalheModal ──────────────────────────────────────────────────────
function CriativoDetalheModal({ criativo: cr, onClose, onUpdate, STATUS_COLORS, ALL_STATUSES }) {
  const [mode, setMode]       = useState("view"); // "view" | "edit"
  const [f, setF]             = useState({
    status: cr.status || "Ideia", hook: cr.hook || "",
    roteiro: cr.roteiro || "", observacoes: cr.observacoes || "",
    resultado: cr.resultado || "", plataforma: cr.plataforma || "Meta",
    tipo: cr.tipo || "Vídeo",
  });
  const [saving, setSaving]   = useState(false);

  const sc = STATUS_COLORS[cr.status];

  async function save() {
    setSaving(true);
    try { await onUpdate(cr.id, f); setMode("view"); }
    catch (e) { alert("Erro: " + (e.message || "tente novamente")); }
    finally { setSaving(false); }
  }

  return (
    <Modal title={cr.nome} subtitle={
      <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
        {sc ? <Tag label={cr.status} bg={sc.bg} color={sc.color} xs /> : <Tag label={cr.status || "Ideia"} xs />}
        {cr.plataforma && <Tag label={cr.plataforma} bg="var(--primary-soft)" color="var(--primary)" xs />}
        {cr.tipo && <Tag label={cr.tipo} bg="var(--line-soft)" color="var(--faint)" xs />}
      </span>
    } onClose={onClose} width={560}>
      {mode === "view" ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {cr.hook && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 5 }}>Hook / Ideia</div>
              <div style={{ fontSize: 13, color: "var(--ink)", lineHeight: 1.6 }}>{cr.hook}</div>
            </div>
          )}
          {cr.roteiro && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 5 }}>Roteiro</div>
              <div style={{ fontSize: 13, color: "var(--ink)", lineHeight: 1.7, whiteSpace: "pre-wrap", background: "var(--surface)", padding: "10px 14px", borderRadius: 8, borderLeft: "3px solid var(--primary-soft)" }}>{cr.roteiro}</div>
            </div>
          )}
          {cr.observacoes && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 5 }}>Observações</div>
              <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{cr.observacoes}</div>
            </div>
          )}
          {cr.resultado && (
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 5 }}>Resultado</div>
              <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.6 }}>{cr.resultado}</div>
            </div>
          )}
          {!cr.hook && !cr.roteiro && !cr.observacoes && !cr.resultado && (
            <div style={{ color: "var(--faint)", fontSize: 13, textAlign: "center", padding: "20px 0" }}>Nenhum detalhe salvo ainda.</div>
          )}
          {onUpdate && (
            <div style={{ display: "flex", gap: 8, paddingTop: 4 }}>
              <Btn variant="accent" sm onClick={() => setMode("edit")}>Editar</Btn>
              <Btn variant="ghost" sm onClick={onClose}>Fechar</Btn>
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: 120 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", marginBottom: 4 }}>Status</div>
              <Sel value={f.status} onChange={(e) => setF((p) => ({ ...p, status: e.target.value }))}>
                {ALL_STATUSES.map((s) => <option key={s}>{s}</option>)}
              </Sel>
            </div>
            <div style={{ flex: 1, minWidth: 100 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", marginBottom: 4 }}>Plataforma</div>
              <Sel value={f.plataforma} onChange={(e) => setF((p) => ({ ...p, plataforma: e.target.value }))}>
                {["Meta","Google","TikTok","Orgânico"].map((p) => <option key={p}>{p}</option>)}
              </Sel>
            </div>
            <div style={{ flex: 1, minWidth: 100 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", marginBottom: 4 }}>Tipo</div>
              <Sel value={f.tipo} onChange={(e) => setF((p) => ({ ...p, tipo: e.target.value }))}>
                {["Vídeo","Imagem","Carrossel","Story","Reels"].map((t) => <option key={t}>{t}</option>)}
              </Sel>
            </div>
          </div>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", marginBottom: 4 }}>Hook / Ideia</div>
            <Txta rows={2} value={f.hook} onChange={(e) => setF((p) => ({ ...p, hook: e.target.value }))} placeholder="Hook / ideia principal..." />
          </div>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", marginBottom: 4 }}>Roteiro</div>
            <Txta rows={5} value={f.roteiro} onChange={(e) => setF((p) => ({ ...p, roteiro: e.target.value }))} placeholder="Roteiro / desenvolvimento do conteúdo..." />
          </div>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", marginBottom: 4 }}>Observações</div>
            <Txta rows={3} value={f.observacoes} onChange={(e) => setF((p) => ({ ...p, observacoes: e.target.value }))} placeholder="Observações, contexto, decisões..." />
          </div>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", marginBottom: 4 }}>Resultado</div>
            <Txta rows={2} value={f.resultado} onChange={(e) => setF((p) => ({ ...p, resultado: e.target.value }))} placeholder="Resultado após veicular (CTR, feedback)..." />
          </div>
          <div style={{ display: "flex", gap: 8, paddingTop: 4 }}>
            <Btn variant="accent" sm onClick={save} disabled={saving}>{saving ? "Salvando..." : "Salvar"}</Btn>
            <Btn variant="ghost" sm onClick={() => setMode("view")}>Cancelar</Btn>
          </div>
        </div>
      )}
    </Modal>
  );
}

// ── CriativosClienteTab ───────────────────────────────────────────────────────
function CriativosClienteTab({ criativos, client, onNewCriativo, onSaveCriativo, onUpdateCriativo }) {
  const [nome, setNome]           = useState("");
  const [hook, setHook]           = useState("");
  const [plataforma, setPlataforma] = useState("Meta");
  const [tipo, setTipo]           = useState("Vídeo");
  const [saving, setSaving]       = useState(false);
  const [filterStatus, setFilterStatus] = useState("Todos");
  const [viewingCriativo, setViewingCriativo] = useState(null);
  const [editFields, setEditFields] = useState({});

  const STATUS_FILTERS  = ["Todos", "Ideia", "Roteirizado", "Criado", "Pendente", "Descartado", "Em teste", "Vencedor"];
  const STATUS_COLORS = {
    "Ideia":       { bg: "var(--cat-violet-soft)", color: "var(--cat-violet-ink)" },
    "Roteirizado": { bg: "var(--success-soft)",    color: "var(--success-ink)" },
    "Criado":      { bg: "var(--info-soft)",       color: "var(--info-ink)" },
    "Pendente":    { bg: "var(--warn-soft)",       color: "var(--warn-ink)" },
    "Descartado":  { bg: "var(--surface-3)",       color: "var(--muted)" },
    "Em teste":    { bg: "var(--cat-orange-soft)", color: "var(--cat-orange-ink)" },
    "Vencedor":    { bg: "var(--success-soft)",    color: "var(--success-ink)" },
  };
  const ALL_STATUSES = ["Ideia","Roteirizado","Criado","Pendente","Descartado","Em teste","Vencedor","Escalado","Pausado"];

  async function quickSave() {
    if (!nome.trim() || !onSaveCriativo) return;
    setSaving(true);
    try {
      await onSaveCriativo({
        client_id: client.id, nome: nome.trim(),
        hook: hook.trim(), plataforma, tipo, status: "Ideia",
      });
      setNome(""); setHook("");
    } catch (e) { alert("Erro ao salvar: " + (e.message || "tente novamente")); }
    finally { setSaving(false); }
  }

  const visible = criativos.filter((cr) =>
    filterStatus === "Todos" || cr.status === filterStatus
  );

  return (
    <div className="tab-pane">
      <BlockHead title={`Criativos (${criativos.length})`} sub="Anote a ideia em uma linha. Roteiro e resultado ficam ao abrir.">
        <Btn sm variant="secondary" onClick={onNewCriativo}>+ Formulário completo</Btn>
      </BlockHead>

      {/* Quick capture */}
      <Card style={{ padding: "14px 16px", marginBottom: 16 }}>
        <div className="eyebrow" style={{ marginBottom: 10 }}>Captura rápida de ideia</div>
        <div style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
          <Inp
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && quickSave()}
            placeholder="Nome do criativo ou ideia..."
            style={{ flex: 1, minWidth: 180 }}
            autoFocus={false}
          />
          <Sel value={plataforma} onChange={(e) => setPlataforma(e.target.value)} style={{ width: 90 }}>
            {["Meta","Google","TikTok","Orgânico"].map((p) => <option key={p}>{p}</option>)}
          </Sel>
          <Sel value={tipo} onChange={(e) => setTipo(e.target.value)} style={{ width: 90 }}>
            {["Vídeo","Imagem","Carrossel","Story","Reels"].map((t) => <option key={t}>{t}</option>)}
          </Sel>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <Inp
            value={hook}
            onChange={(e) => setHook(e.target.value)}
            placeholder="Hook / Descrição da ideia (opcional)..."
            style={{ flex: 1, fontSize: 12 }}
          />
          <Btn variant="primary" sm onClick={quickSave} disabled={saving || !nome.trim()}>
            {saving ? "..." : "+ Salvar"}
          </Btn>
        </div>
      </Card>

      {/* Filtros de status */}
      {criativos.length > 0 && (
        <Chips label="Filtrar por situação" active={filterStatus} onChange={setFilterStatus} style={{ marginBottom: 12 }}
          items={STATUS_FILTERS.map((s) => ({ id: s, label: s, count: s === "Todos" ? criativos.length : criativos.filter((cr) => cr.status === s).length }))} />
      )}

      {/* Lista: uma linha por criativo; hook, roteiro e situação rápida ao abrir */}
      <ExpandTable
        minWidth={560}
        rows={visible}
        empty={criativos.length === 0 ? "Nenhuma ideia ainda. Use a captura rápida acima." : "Nenhum criativo nesta situação."}
        columns={[
          { key: "nome", label: "Criativo", render: (cr) => (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
              <Dot color={STATUS_COLORS[cr.status]?.color || CR_COLORS[cr.status] || "var(--faint)"} size={7} />
              <span className="name">{cr.nome}</span>
            </span>
          ) },
          { key: "plat", label: "Onde", render: (cr) => <span className="sub">{[cr.plataforma, cr.tipo].filter(Boolean).join(" · ") || "—"}</span> },
          { key: "status", label: "Situação", render: (cr) => {
            const sc = STATUS_COLORS[cr.status];
            return <span className="badge" style={{ background: sc?.bg || "var(--surface-3)", color: sc?.color || "var(--muted)" }}>{cr.status || "Ideia"}</span>;
          } },
        ]}
        detail={(cr) => (
          <div className="detail-grid">
            <Detalhe label="Hook / ideia">{cr.hook}</Detalhe>
            {cr.roteiro && <Detalhe label="Roteiro" pre>{resumo(cr.roteiro, 280)}</Detalhe>}
            <div className="detail-actions">
              <Btn sm variant="primary" onClick={() => setViewingCriativo(cr)}>Abrir ficha</Btn>
              {onUpdateCriativo && (
                <Chips label="Mudar situação" active={cr.status} onChange={(s) => onUpdateCriativo(cr.id, { status: s })}
                  items={["Criado", "Pendente", "Descartado"].map((s) => ({ id: s, label: s }))} />
              )}
            </div>
          </div>
        )}
      />

      {/* Modal de detalhe/edição */}
      {viewingCriativo && (
        <CriativoDetalheModal
          criativo={viewingCriativo}
          onClose={() => setViewingCriativo(null)}
          onUpdate={onUpdateCriativo ? async (id, data) => {
            await onUpdateCriativo(id, data);
            setViewingCriativo((prev) => ({ ...prev, ...data }));
          } : null}
          STATUS_COLORS={STATUS_COLORS}
          ALL_STATUSES={ALL_STATUSES}
        />
      )}
    </div>
  );
}

// ── ConcorrentesClienteTab ────────────────────────────────────────────────────
function ConcorrentesClienteTab({ concorrentes, clientId }) {
  const filtered = concorrentes.filter((c) =>
    Array.isArray(c.client_ids) && c.client_ids.includes(clientId)
  );
  return (
    <div className="tab-pane">
      <BlockHead title={`Concorrentes (${filtered.length})`} sub="Cadastro e edição ficam em Concorrentes, no menu." />
      <ExpandTable
        minWidth={480}
        rows={filtered}
        empty="Nenhum concorrente mapeado para este nicho. Acesse Concorrentes no menu para cadastrar."
        columns={[
          { key: "nome", label: "Concorrente", render: (c) => <span className="name">{c.nome}</span> },
          { key: "ig", label: "Instagram", render: (c) => <span className="sub">{c.instagram ? `@${c.instagram}` : "—"}</span> },
          { key: "dif", label: "Diferencial", render: (c) => <span className="sub">{resumo(c.diferencial, 60) || "—"}</span> },
        ]}
        detail={(c) => (
          <div className="detail-grid">
            <Detalhe label="Diferencial">{c.diferencial || "Sem diferencial anotado."}</Detalhe>
          </div>
        )}
      />
    </div>
  );
}

// ── AnaliseModal ──────────────────────────────────────────────────────────────
function AnaliseModal({ initial, client, onClose, onSave, onDelete }) {
  const [f, setF] = useState(initial || {
    tipo: "AC", mes: curMonth(), titulo: "", conteudo: "", status: "Concluído",
  });
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [saving, setSaving]       = useState(false);
  const [confirming, setConfirming] = useState(false);

  async function save() {
    if (!f.titulo.trim()) return;
    setSaving(true);
    await onSave(f);
    setSaving(false);
  }

  return (
    <Modal title={initial ? "Editar análise" : "Nova análise"} onClose={onClose} width={640}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <FormRow>
          <Field label="Tipo" half>
            <Sel value={f.tipo} onChange={(e) => {
              const tipo = e.target.value;
              up("tipo", tipo);
              if (!initial) up("titulo", `${tipo} — ${client.name}`);
            }}>
              {TIPOS_ANALISE.map((t) => <option key={t}>{t}</option>)}
            </Sel>
          </Field>
          <Field label="Mês" half>
            <Inp value={f.mes || ""} onChange={(e) => up("mes", e.target.value)} placeholder="05/2026" />
          </Field>
        </FormRow>
        <Field label="Título">
          <Inp value={f.titulo} onChange={(e) => up("titulo", e.target.value)} placeholder="Ex: AC Semana 3 — Dr. Victor Couto" />
        </Field>
        <Field label="Conteúdo da análise">
          <Txta rows={14} value={f.conteudo || ""} onChange={(e) => up("conteudo", e.target.value)}
            placeholder={"## Resumo\n\n## Gargalos identificados\n\n## Hipóteses validadas\n\n## Próximos passos"} />
        </Field>
        <FormRow>
          <Field label="Status" half>
            <Sel value={f.status} onChange={(e) => up("status", e.target.value)}>
              {["Concluído","Rascunho"].map((s) => <option key={s}>{s}</option>)}
            </Sel>
          </Field>
        </FormRow>
        <Btn variant="accent" full onClick={save} disabled={saving || !f.titulo.trim()}>
          {saving ? "Salvando..." : "Salvar análise"}
        </Btn>
        {initial && onDelete && (
          confirming ? (
            <div style={{ display: "flex", gap: 8 }}>
              <Btn variant="danger" full onClick={onDelete}>Confirmar exclusão</Btn>
              <Btn variant="ghost" full onClick={() => setConfirming(false)}>Cancelar</Btn>
            </div>
          ) : (
            <Btn variant="ghost" full onClick={() => setConfirming(true)} style={{ color: "var(--danger)" }}>
              Excluir análise
            </Btn>
          )
        )}
      </div>
    </Modal>
  );
}

// ── AnalisesClienteTab ────────────────────────────────────────────────────────
function AnalisesClienteTab({ client, analises, onNew, onUpdate, onDelete }) {
  const [showForm, setShowForm]   = useState(false);
  const [selected, setSelected]   = useState(null);
  const [filterTipo, setFilterTipo] = useState("Todos");

  const tipos   = ["Todos", ...new Set(analises.map((a) => a.tipo))];
  const visible = filterTipo === "Todos" ? analises : analises.filter((a) => a.tipo === filterTipo);

  return (
    <div className="tab-pane">
      <BlockHead title="Análises" sub="Uma linha por análise. O texto completo abre ao clicar.">
        <Btn sm variant="primary" onClick={() => setShowForm(true)}>+ Nova análise</Btn>
      </BlockHead>

      {tipos.length > 2 && (
        <Chips label="Filtrar por tipo" active={filterTipo} onChange={setFilterTipo} style={{ marginBottom: 12 }}
          items={tipos.map((t) => ({ id: t, label: t, count: t === "Todos" ? analises.length : analises.filter((a) => a.tipo === t).length }))} />
      )}

      <ExpandTable
        minWidth={560}
        rows={visible}
        empty="Nenhuma análise registrada ainda."
        columns={[
          { key: "titulo", label: "Análise", render: (a) => <span className="name">{a.titulo}</span> },
          { key: "tipo", label: "Tipo", render: (a) => {
            const st = ANALISE_TIPO_STYLE[a.tipo] || { bg: "var(--surface-3)", color: "var(--muted)" };
            return <span className="badge" style={{ background: st.bg, color: st.color }}>{a.tipo}</span>;
          } },
          { key: "mes", label: "Mês", render: (a) => <span className="sub">{a.mes || "—"}</span> },
          { key: "status", label: "Situação", render: (a) => <Selo tone={a.status === "Rascunho" ? "warn" : "ok"}>{a.status || "Concluído"}</Selo> },
        ]}
        detail={(a) => (
          <div className="detail-grid">
            <Detalhe label="Conteúdo" pre>{a.conteudo || "Sem conteúdo."}</Detalhe>
            <div className="detail-actions">
              <Btn sm variant="secondary" onClick={() => setSelected(a)}>Editar</Btn>
            </div>
          </div>
        )}
      />

      {showForm && (
        <AnaliseModal
          client={client}
          onClose={() => setShowForm(false)}
          onSave={async (data) => { await onNew({ ...data, client_id: client.id }); setShowForm(false); }}
        />
      )}
      {selected && (
        <AnaliseModal
          initial={selected}
          client={client}
          onClose={() => setSelected(null)}
          onSave={async (data) => { await onUpdate(selected.id, data); setSelected(null); }}
          onDelete={async () => { await onDelete(selected.id); setSelected(null); }}
        />
      )}
    </div>
  );
}


// ── OtimizacoesTab ────────────────────────────────────────────────────────────
function OtimizacaoModal({ initial, client, onClose, onSave, onDelete }) {
  const [f, setF] = useState(initial || {
    titulo: "", descricao: "", plataforma: "", status: "Testado",
    resultado: "", impacto: "Médio", data: new Date().toISOString().split("T")[0],
  });
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!f.titulo.trim()) return;
    setSaving(true);
    await onSave(f);
    setSaving(false);
  }

  return (
    <Modal title={initial ? "Editar otimização" : "Nova otimização"} onClose={onClose} width={560}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Field label="Título da ação">
          <Inp value={f.titulo} onChange={(e) => up("titulo", e.target.value)} placeholder="Ex: Trocar público lookalike por interesse manual..." />
        </Field>
        <FormRow>
          <Field label="Plataforma" half>
            <Sel value={f.plataforma} onChange={(e) => up("plataforma", e.target.value)}>
              <option value="">Selecionar...</option>
              {OTIM_PLATAFORMAS.map((p) => <option key={p}>{p}</option>)}
            </Sel>
          </Field>
          <Field label="Status" half>
            <Sel value={f.status} onChange={(e) => up("status", e.target.value)}>
              {OTIM_STATUSES.map((s) => <option key={s}>{s}</option>)}
            </Sel>
          </Field>
        </FormRow>
        <FormRow>
          <Field label="Impacto" half>
            <Sel value={f.impacto} onChange={(e) => up("impacto", e.target.value)}>
              {["Alto", "Médio", "Baixo"].map((i) => <option key={i}>{i}</option>)}
            </Sel>
          </Field>
          <Field label="Data" half>
            <Inp type="date" value={f.data} onChange={(e) => up("data", e.target.value)} />
          </Field>
        </FormRow>
        <Field label="Descrição / Hipótese">
          <Txta rows={3} value={f.descricao || ""} onChange={(e) => up("descricao", e.target.value)}
            placeholder="Por que foi feito? Qual era a hipótese testada?" />
        </Field>
        <Field label="Resultado observado">
          <Txta rows={2} value={f.resultado || ""} onChange={(e) => up("resultado", e.target.value)}
            placeholder="O que aconteceu depois? CTR subiu? CPL caiu?" />
        </Field>
        <Btn variant="accent" full onClick={save} disabled={saving || !f.titulo.trim()}>
          {saving ? "Salvando..." : "Salvar"}
        </Btn>
        {initial && onDelete && (
          <Btn variant="ghost" full onClick={onDelete} style={{ color: "var(--danger)" }}>
            Excluir
          </Btn>
        )}
      </div>
    </Modal>
  );
}

function OtimizacoesTab({ client, otimizacoes, tasks = [], onNew, onUpdate, onDelete }) {
  const [showForm, setShowForm]   = useState(false);
  const [selected, setSelected]   = useState(null);
  const [filterStatus, setFilter] = useState("Todos");
  const [showLegacy, setShowLegacy] = useState(true);

  // Surfacear otimizações registradas dentro das tarefas (task.history[])
  const legacyItems = [];
  tasks.forEach((t) => {
    (t.history || []).forEach((h) => {
      if (!h.action?.trim()) return;
      legacyItems.push({
        id:          `legacy-${t.id}-${h.id}`,
        isLegacy:    true,
        sourceName:  t.name,
        data:        h.date || t.created_at?.split("T")[0],
        titulo:      h.action,
        descricao:   h.reason   || null,
        resultado:   h.notes    || h.expected || null,
        plataforma:  t.type,
        status:      "Testado",
        impacto:     null,
      });
    });
  });

  const allNew = otimizacoes;
  const allItems = [...allNew, ...(showLegacy ? legacyItems : [])];

  const filtered = filterStatus === "Todos"
    ? allItems
    : allItems.filter((o) => o.status === filterStatus);

  const counts = OTIM_STATUSES.reduce((acc, s) => {
    acc[s] = allItems.filter((o) => o.status === s).length;
    return acc;
  }, {});

  return (
    <div className="tab-pane">
      <BlockHead title="Otimizações" sub="O que foi testado nesta conta. Hipótese e resultado abrem na linha.">
        <Btn sm variant="primary" onClick={() => setShowForm(true)}>+ Registrar ação</Btn>
      </BlockHead>

      <div className="tab-bar">
        <Chips label="Filtrar por situação" active={filterStatus} onChange={setFilter}
          items={["Todos", ...OTIM_STATUSES].map((s) => ({ id: s, label: s, count: s === "Todos" ? allItems.length : counts[s] }))} />
        {legacyItems.length > 0 && (
          <label style={{ display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13, color: "var(--muted)", cursor: "pointer" }}>
            <Check on={showLegacy} onClick={() => setShowLegacy(!showLegacy)} label="Mostrar registros das tarefas" />
            Registros das tarefas ({legacyItems.length})
          </label>
        )}
      </div>

      <ExpandTable
        minWidth={640}
        rows={filtered}
        empty="Nenhuma ação registrada. Comece registrando o que foi testado nesta conta."
        columns={[
          { key: "data", label: "Data", render: (o) => <span className="sub">{fmtDate(o.data)}</span> },
          { key: "titulo", label: "Ação", render: (o) => (
            <div style={{ minWidth: 0 }}>
              <div className="name">{resumo(o.titulo, 80)}</div>
              {o.isLegacy && o.sourceName && <div className="sub">da tarefa {o.sourceName}</div>}
            </div>
          ) },
          { key: "plat", label: "Onde", render: (o) => <span className="sub">{o.plataforma || "—"}</span> },
          { key: "imp", label: "Impacto", render: (o) => o.impacto ? <Selo tone={IMPACTO_TONE[o.impacto] || "off"} dot={false}>{o.impacto}</Selo> : <span className="sub">—</span> },
          { key: "status", label: "Situação", render: (o) => <Selo tone={OTIM_TONE[o.status] || "off"}>{o.status}</Selo> },
        ]}
        detail={(o) => (
          <div className="detail-grid">
            <Detalhe label="Hipótese / descrição" pre>{o.descricao}</Detalhe>
            <Detalhe label="Resultado" pre>{o.resultado}</Detalhe>
            {!o.descricao && !o.resultado && <span className="sub">Sem hipótese nem resultado anotados.</span>}
            {!o.isLegacy && (
              <div className="detail-actions">
                <Btn sm variant="secondary" onClick={() => setSelected(o)}>Editar</Btn>
              </div>
            )}
          </div>
        )}
      />

      {showForm && (
        <OtimizacaoModal
          client={client}
          onClose={() => setShowForm(false)}
          onSave={async (data) => { await onNew({ ...data, client_id: client.id }); setShowForm(false); }}
        />
      )}
      {selected && (
        <OtimizacaoModal
          initial={selected}
          client={client}
          onClose={() => setSelected(null)}
          onSave={async (data) => { await onUpdate(selected.id, data); setSelected(null); }}
          onDelete={async () => { await onDelete(selected.id); setSelected(null); }}
        />
      )}
    </div>
  );
}

// ── AnotacoesTab ──────────────────────────────────────────────────────────────
function AnotacoesTab({ client, anotacoes, onNew, onDelete }) {
  const [showForm, setShowForm] = useState(false);
  const [tipo, setTipo]         = useState("Reunião");
  const [titulo, setTitulo]     = useState("");
  const [conteudo, setConteudo] = useState("");
  const [data, setData]         = useState(new Date().toISOString().split("T")[0]);
  const [saving, setSaving]     = useState(false);
  const [confirmDel, setConfirmDel] = useState(null);

  const TIPO_STYLE = {
    "Reunião":  { bg: "var(--info-soft)",       color: "var(--info-ink)" },
    "Nota":     { bg: "var(--cat-violet-soft)", color: "var(--cat-violet-ink)" },
    "Feedback": { bg: "var(--warn-soft)",       color: "var(--warn-ink)" },
    "Decisão":  { bg: "var(--success-soft)",    color: "var(--success-ink)" },
  };

  async function save() {
    if (!conteudo.trim()) return;
    setSaving(true);
    await onNew({ client_id: client.id, data, tipo, titulo: titulo || null, conteudo });
    setConteudo(""); setTitulo(""); setTipo("Reunião");
    setData(new Date().toISOString().split("T")[0]);
    setShowForm(false);
    setSaving(false);
  }

  return (
    <div className="tab-pane">
      <BlockHead title={`Anotações e reuniões (${anotacoes.length})`} sub="Uma linha por registro. O texto abre ao clicar.">
        <Btn sm variant="primary" onClick={() => setShowForm(!showForm)}>+ Nova anotação</Btn>
      </BlockHead>

      {client.estrategias_utilizadas && (
        <div style={{ marginBottom: 14 }}>
          <Explica tone="warn" title="Estratégias registradas antes (campo do cadastro do cliente)">
            <div style={{ whiteSpace: "pre-wrap", color: "var(--ink)" }}>{client.estrategias_utilizadas}</div>
          </Explica>
        </div>
      )}

      {showForm && (
        <Card style={{ padding: "16px 18px", marginBottom: 16 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <FormRow>
              <Field label="Tipo" half>
                <Sel value={tipo} onChange={(e) => setTipo(e.target.value)}>
                  {ANOTACAO_TIPOS.map((t) => <option key={t}>{t}</option>)}
                </Sel>
              </Field>
              <Field label="Data" half>
                <Inp type="date" value={data} onChange={(e) => setData(e.target.value)} />
              </Field>
            </FormRow>
            <Field label="Título (opcional)">
              <Inp value={titulo} onChange={(e) => setTitulo(e.target.value)} placeholder="Ex: Reunião semanal — semana 2 jun" />
            </Field>
            <Field label="Conteúdo">
              <Txta
                rows={4}
                value={conteudo}
                onChange={(e) => setConteudo(e.target.value)}
                placeholder="O que foi discutido? Decisões tomadas, ajustes combinados, feedbacks recebidos..."
              />
            </Field>
            <div style={{ display: "flex", gap: 8 }}>
              <Btn variant="primary" onClick={save} disabled={saving || !conteudo.trim()}>
                {saving ? "Salvando..." : "Salvar"}
              </Btn>
              <Btn variant="ghost" onClick={() => setShowForm(false)}>Cancelar</Btn>
            </div>
          </div>
        </Card>
      )}

      <ExpandTable
        minWidth={520}
        rows={anotacoes}
        empty="Nenhuma anotação registrada. Registre reuniões, feedbacks e decisões para manter o histórico."
        columns={[
          { key: "data", label: "Data", render: (a) => <span className="sub">{fmtDate(a.data)}</span> },
          { key: "tipo", label: "Tipo", render: (a) => {
            const st = TIPO_STYLE[a.tipo] || TIPO_STYLE["Nota"];
            return <span className="badge" style={{ background: st.bg, color: st.color }}>{a.tipo}</span>;
          } },
          { key: "titulo", label: "Assunto", render: (a) => <span className="name">{a.titulo || resumo(a.conteudo, 70)}</span> },
        ]}
        detail={(a) => (
          <div className="detail-grid">
            <Detalhe label="Registro" pre>{a.conteudo}</Detalhe>
            <div className="detail-actions">
              {confirmDel === a.id ? (
                <>
                  <span className="sub">Excluir esta anotação?</span>
                  <Btn sm variant="danger" onClick={async () => { await onDelete(a.id); setConfirmDel(null); }}>Sim, excluir</Btn>
                  <Btn sm variant="ghost" onClick={() => setConfirmDel(null)}>Não</Btn>
                </>
              ) : (
                <Btn sm variant="ghost" onClick={() => setConfirmDel(a.id)}>Excluir</Btn>
              )}
            </div>
          </div>
        )}
      />
    </div>
  );
}

// ── SocialMediaClienteTab ─────────────────────────────────────────────────────
const FORMATO_SM = {
  "Story":     { bg: "var(--success-soft)",    color: "var(--success-ink)" },
  "Feed":      { bg: "var(--info-soft)",       color: "var(--info-ink)" },
  "Carrossel": { bg: "var(--cat-violet-soft)", color: "var(--cat-violet-ink)" },
};

function SocialPostModal({ initial, client, onClose, onSave }) {
  const today = new Date().toISOString().split("T")[0];
  const [f, setF] = useState(initial || {
    data_prevista: today, formato: "Feed", tema: "", headline: "",
    body_copy: "", legenda: "", hashtags: "", status: "pendente",
  });
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!f.tema.trim()) return;
    setSaving(true);
    await onSave(f);
    setSaving(false);
  }

  return (
    <Modal title={initial ? "Editar post" : "Novo post"} subtitle={client.name} onClose={onClose} width={580}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <FormRow>
          <Field label="Data prevista" half>
            <Inp type="date" value={f.data_prevista} onChange={(e) => up("data_prevista", e.target.value)} />
          </Field>
          <Field label="Formato" half>
            <Sel value={f.formato} onChange={(e) => up("formato", e.target.value)}>
              {["Story", "Feed", "Carrossel"].map((t) => <option key={t}>{t}</option>)}
            </Sel>
          </Field>
        </FormRow>
        <Field label="Tema">
          <Inp value={f.tema} onChange={(e) => up("tema", e.target.value)} placeholder="Ex: Joelho — 5 sinais de alerta" />
        </Field>
        <Field label="Headline">
          <Inp value={f.headline} onChange={(e) => up("headline", e.target.value)} placeholder="Headline principal do post" />
        </Field>
        <Field label="Body copy / Conteúdo">
          <Txta rows={4} value={f.body_copy} onChange={(e) => up("body_copy", e.target.value)} placeholder="Desenvolvimento do conteúdo por tela / slide..." />
        </Field>
        <Field label="Legenda">
          <Txta rows={3} value={f.legenda} onChange={(e) => up("legenda", e.target.value)} placeholder="Legenda completa para o post..." />
        </Field>
        <Field label="Hashtags">
          <Inp value={f.hashtags} onChange={(e) => up("hashtags", e.target.value)} placeholder="#ortopedia #joelho #drgutembergoliveira" />
        </Field>
        <Btn variant="accent" full onClick={save} disabled={saving || !f.tema.trim()}>
          {saving ? "Salvando..." : "Salvar post"}
        </Btn>
      </div>
    </Modal>
  );
}

function SocialMediaClienteTab({ posts, client, onNew, onUpdate, onDelete }) {
  const [filter, setFilter]       = useState("pendente");
  const [showForm, setShowForm]   = useState(false);
  const [selected, setSelected]   = useState(null);
  const [gerando, setGerando]     = useState(false);
  const [gerarErro, setGerarErro] = useState("");
  const [gerarOk, setGerarOk]     = useState("");

  const today = new Date().toISOString().split("T")[0];

  const atrasados   = posts.filter((p) => p.status === "pendente" && p.data_prevista < today);
  const programados = posts.filter((p) => p.status === "pendente" && p.data_prevista >= today);
  const postados    = posts.filter((p) => p.status === "postado").sort((a, b) => (b.data_postagem || "").localeCompare(a.data_postagem || ""));
  const pulados     = posts.filter((p) => p.status === "pulado");

  const counts = {
    pendente: atrasados.length + programados.length,
    postado:  postados.length,
    pulado:   pulados.length,
    todos:    posts.length,
  };

  let visible = [];
  if (filter === "pendente")  visible = [...atrasados, ...programados];
  else if (filter === "postado") visible = postados;
  else if (filter === "pulado")  visible = pulados;
  else visible = [...atrasados, ...programados, ...postados, ...pulados];

  const pctPostados = posts.length ? Math.round((postados.length / posts.length) * 100) : 0;

  async function marcarPostado(post) {
    await onUpdate(post.id, { status: "postado", data_postagem: today });
  }
  async function pularPost(post) {
    await onUpdate(post.id, { status: "pulado" });
  }
  async function desfazer(post) {
    await onUpdate(post.id, { status: "pendente", data_postagem: null });
  }

  async function handleGerar() {
    setGerando(true);
    setGerarErro("");
    setGerarOk("");
    try {
      const novos = await gerarSocialPosts(client, posts);
      if (!novos || novos.length === 0) throw new Error("Nenhum post gerado. Tente novamente.");
      for (const post of novos) {
        await onNew(post);
      }
      const fmt = (d) => d.split("-").reverse().slice(0, 2).join("/");
      const inicio = fmt(novos[0].data_prevista);
      const fim    = fmt(novos[novos.length - 1].data_prevista);
      setGerarOk(`${novos.length} posts gerados para ${inicio} → ${fim}`);
      setFilter("pendente");
    } catch (e) {
      setGerarErro(e.message || "Erro ao gerar. Tente novamente.");
    } finally {
      setGerando(false);
    }
  }

  return (
    <div className="tab-pane">
      <BlockHead title="Social Media" sub="Calendário de posts. Copy completo abre na linha.">
        <Btn sm variant="primary" onClick={handleGerar} disabled={gerando}>
          {gerando ? "Gerando com IA..." : "✦ Gerar próximo período"}
        </Btn>
        <Btn sm variant="secondary" onClick={() => setShowForm(true)}>+ Novo post</Btn>
      </BlockHead>

      <KpiStrip style={{ marginBottom: 14 }} items={[
        { label: "Postados", value: postados.length, sub: posts.length ? `${pctPostados}% do período` : "nenhum post", tone: pctPostados === 100 ? "ok" : "" },
        { label: "Pendentes", value: counts.pendente },
        { label: "Atrasados", value: atrasados.length, sub: atrasados.length ? "publicar ou pular" : "em dia", tone: atrasados.length ? "bad" : "ok", color: atrasados.length ? "var(--danger)" : undefined },
        { label: "Pulados", value: pulados.length },
      ]} />

      {gerarOk && (
        <div className="alert-line ok" role="status">✓ {gerarOk}<button type="button" className="x" aria-label="Fechar" onClick={() => setGerarOk("")}>✕</button></div>
      )}
      {gerarErro && (
        <div className="alert-line bad" role="alert">{gerarErro}<button type="button" className="x" aria-label="Fechar" onClick={() => setGerarErro("")}>✕</button></div>
      )}

      <Chips label="Filtrar posts" active={filter} onChange={setFilter} style={{ marginBottom: 12 }} items={[
        { id: "pendente", label: "Pendentes", count: counts.pendente },
        { id: "postado",  label: "Postados",  count: counts.postado },
        { id: "pulado",   label: "Pulados",   count: counts.pulado },
        { id: "todos",    label: "Todos",     count: counts.todos },
      ]} />

      <ExpandTable
        minWidth={640}
        rows={visible}
        empty={
          filter === "pendente" ? "Nenhum post pendente. Todos publicados ou pulados." :
          filter === "postado"  ? "Nenhum post publicado ainda neste período." :
          filter === "pulado"   ? "Nenhum post pulado." :
          "Nenhum post cadastrado. Clique em + Novo post para começar."
        }
        columns={[
          { key: "data", label: "Data", render: (post) => {
            const atrasado = post.status === "pendente" && post.data_prevista < today;
            return <span style={{ fontSize: 13, color: atrasado ? "var(--danger)" : "var(--muted)", fontWeight: atrasado ? 600 : 400 }}>{post.data_prevista?.split("-").reverse().join("/")}</span>;
          } },
          { key: "fmt", label: "Formato", render: (post) => {
            const st = FORMATO_SM[post.formato] || { bg: "var(--surface-3)", color: "var(--muted)" };
            return <span className="badge" style={{ background: st.bg, color: st.color }}>{post.formato}</span>;
          } },
          { key: "tema", label: "Tema", render: (post) => <span className="name">{post.tema}</span> },
          { key: "status", label: "Situação", render: (post) => {
            const atrasado = post.status === "pendente" && post.data_prevista < today;
            if (post.status === "postado") return <Selo tone="ok">{post.data_postagem ? `postado ${post.data_postagem.split("-").reverse().slice(0, 2).join("/")}` : "postado"}</Selo>;
            if (post.status === "pulado") return <Selo tone="off">pulado</Selo>;
            return atrasado ? <Selo tone="bad">atrasado</Selo> : <Selo tone="info">pendente</Selo>;
          } },
          { key: "acao", label: "", align: "right", render: (post) => (
            <span style={{ display: "inline-flex", gap: 6 }} onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
              {post.status === "pendente"
                ? <Btn sm variant="secondary" onClick={() => marcarPostado(post)}>✓ Postado</Btn>
                : <Btn sm variant="ghost" onClick={() => desfazer(post)}>↩ Desfazer</Btn>}
            </span>
          ) },
        ]}
        detail={(post) => (
          <div className="detail-grid">
            {post.headline && <Detalhe label="Headline">“{post.headline}”</Detalhe>}
            <Detalhe label="Body copy" pre>{post.body_copy}</Detalhe>
            <Detalhe label="Legenda" pre>{post.legenda}</Detalhe>
            {post.hashtags && <div style={{ fontSize: 12.5, color: "var(--primary)", lineHeight: 1.6 }}>{post.hashtags}</div>}
            <div className="detail-actions">
              <Btn sm variant="secondary" onClick={() => setSelected(post)}>Editar</Btn>
              {post.status === "pendente" && <Btn sm variant="ghost" onClick={() => pularPost(post)}>→ Pular</Btn>}
              <Btn sm variant="ghost" onClick={() => { if (window.confirm("Excluir post?")) onDelete(post.id); }}>Excluir</Btn>
            </div>
          </div>
        )}
      />
      {showForm && (
        <SocialPostModal
          client={client}
          onClose={() => setShowForm(false)}
          onSave={async (data) => { await onNew({ ...data, client_id: client.id }); setShowForm(false); }}
        />
      )}
      {selected && (
        <SocialPostModal
          initial={selected}
          client={client}
          onClose={() => setSelected(null)}
          onSave={async (data) => { await onUpdate(selected.id, data); setSelected(null); }}
        />
      )}
    </div>
  );
}

// ── EstrategiaTab ─────────────────────────────────────────────────────────────
const FASE_STATUS = {
  concluida:    { label: "✓ Concluída",    bg: "var(--success-soft)", color: "var(--success-ink)" },
  em_andamento: { label: "● Em andamento", bg: "var(--primary-soft)", color: "var(--primary)" },
  aguardando:   { label: "⏸ Aguardando",   bg: "var(--warn-soft)",    color: "var(--warn-ink)" },
  planejada:    { label: "○ Planejada",    bg: "var(--surface-3)",   color: "var(--muted)" },
};

const FASE_TONE = { concluida: "ok", em_andamento: "info", aguardando: "warn", planejada: "off" };

function FaseModal({ initial, onClose, onSave, onDelete }) {
  const [f, setF]               = useState(initial || { titulo: "", descricao: "", status: "planejada", acoes: [] });
  const [novaAcao, setNovaAcao] = useState({ texto: "", responsavel: "" });
  const [saving, setSaving]     = useState(false);
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));

  function addAcao() {
    if (!novaAcao.texto.trim()) return;
    up("acoes", [...(f.acoes || []), { id: uid(), texto: novaAcao.texto.trim(), responsavel: novaAcao.responsavel.trim(), feito: false }]);
    setNovaAcao({ texto: "", responsavel: "" });
  }

  function removeAcao(id) { up("acoes", (f.acoes || []).filter((a) => a.id !== id)); }

  async function save() {
    if (!f.titulo.trim()) return;
    setSaving(true);
    try { await onSave(f); } finally { setSaving(false); }
  }

  return (
    <Modal title={initial ? "Editar Fase" : "Nova Fase"} onClose={onClose} width={560}>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <Field label="Título da fase">
          <Inp value={f.titulo} onChange={(e) => up("titulo", e.target.value)} placeholder="Ex: Fase 1 — Reativação Imediata" />
        </Field>
        <Field label="Descrição">
          <Txta value={f.descricao || ""} onChange={(e) => up("descricao", e.target.value)} rows={3} placeholder="O que acontece nesta fase e por quê é importante..." />
        </Field>
        <Field label="Status">
          <Sel value={f.status} onChange={(e) => up("status", e.target.value)}>
            {Object.entries(FASE_STATUS).map(([k, v]) => (
              <option key={k} value={k}>{v.label}</option>
            ))}
          </Sel>
        </Field>

        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 8 }}>Ações</div>
          {(f.acoes || []).map((a) => (
            <div key={a.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderBottom: "1px solid var(--line-soft)" }}>
              <span style={{ fontSize: 12, flex: 1, color: "var(--ink)" }}>{a.texto}</span>
              {a.responsavel && <span style={{ fontSize: 11, color: "var(--muted)", flexShrink: 0 }}>{a.responsavel}</span>}
              <button onClick={() => removeAcao(a.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--faint)", fontSize: 13, lineHeight: 1 }}>✕</button>
            </div>
          ))}
          <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
            <Inp
              value={novaAcao.texto}
              onChange={(e) => setNovaAcao((p) => ({ ...p, texto: e.target.value }))}
              onKeyDown={(e) => e.key === "Enter" && addAcao()}
              placeholder="Descreva a ação..."
              style={{ flex: 1 }}
            />
            <Inp
              value={novaAcao.responsavel}
              onChange={(e) => setNovaAcao((p) => ({ ...p, responsavel: e.target.value }))}
              placeholder="Responsável"
              style={{ width: 120 }}
            />
            <Btn sm variant="secondary" onClick={addAcao}>+</Btn>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 4 }}>
          <div>
            {initial && onDelete && (
              <Btn sm variant="danger" onClick={() => { if (window.confirm("Excluir esta fase?")) onDelete(initial.id); }}>
                Excluir
              </Btn>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <Btn sm variant="ghost" onClick={onClose}>Cancelar</Btn>
            <Btn sm variant="primary" onClick={save} disabled={saving || !f.titulo.trim()}>
              {saving ? "Salvando..." : "Salvar"}
            </Btn>
          </div>
        </div>
      </div>
    </Modal>
  );
}

function EstrategiaTab({ client }) {
  const [fases, setFases]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing]   = useState(null);

  useEffect(() => {
    db("rc2_estrategias", "GET", null, `?client_id=eq.${client.id}&order=ordem.asc`)
      .then((d) => setFases(d || []))
      .catch(() => setFases([]))
      .finally(() => setLoading(false));
  }, [client.id]);

  async function toggleAcao(faseId, acaoId) {
    const fase     = fases.find((f) => f.id === faseId);
    const newAcoes = (fase.acoes || []).map((a) => a.id === acaoId ? { ...a, feito: !a.feito } : a);
    await db("rc2_estrategias", "PATCH", { acoes: newAcoes, updated_at: new Date().toISOString() }, `?id=eq.${faseId}`);
    setFases((prev) => prev.map((f) => f.id === faseId ? { ...f, acoes: newAcoes } : f));
  }

  async function handleNew(data) {
    const maxOrdem = fases.length > 0 ? Math.max(...fases.map((f) => f.ordem)) : -1;
    const created  = await db("rc2_estrategias", "POST", { ...data, client_id: client.id, ordem: maxOrdem + 1 });
    setFases((prev) => [...prev, created[0]]);
    setShowForm(false);
  }

  async function handleUpdate(data) {
    const updated = await db("rc2_estrategias", "PATCH", { ...data, updated_at: new Date().toISOString() }, `?id=eq.${editing.id}`);
    setFases((prev) => prev.map((f) => f.id === editing.id ? updated[0] : f));
    setEditing(null);
  }

  async function handleDelete(id) {
    await db("rc2_estrategias", "DELETE", null, `?id=eq.${id}`);
    setFases((prev) => prev.filter((f) => f.id !== id));
    setEditing(null);
  }

  if (loading) return <div style={{ padding: "20px 0", display: "flex", alignItems: "center", gap: 10 }}><Spinner size={18} /><span style={{ fontSize: 13, color: "var(--muted)" }}>Carregando estratégia...</span></div>;

  const concluidas  = fases.filter((f) => f.status === "concluida").length;
  const emAndamento = fases.filter((f) => f.status === "em_andamento").length;

  return (
    <div className="tab-pane">
      <BlockHead
        title={`Estratégia: ${fases.length} ${fases.length === 1 ? "fase" : "fases"}`}
        sub={fases.length ? `${concluidas} concluída${concluidas !== 1 ? "s" : ""} · ${emAndamento} em andamento. Ações abrem na linha.` : "Fases do plano do cliente, na ordem."}
      >
        <Btn sm variant="primary" onClick={() => setShowForm(true)}>+ Nova fase</Btn>
      </BlockHead>

      <ExpandTable
        minWidth={560}
        rows={fases}
        empty="Nenhuma fase cadastrada. Clique em + Nova fase para começar."
        columns={[
          { key: "titulo", label: "Fase", render: (fase) => <span className="name">{fase.titulo}</span> },
          { key: "status", label: "Situação", render: (fase) => {
            const st = FASE_STATUS[fase.status] || FASE_STATUS.planejada;
            return <Selo tone={FASE_TONE[fase.status] || "off"}>{st.label.replace(/^[^A-Za-zÀ-ú]+/, "")}</Selo>;
          } },
          { key: "acoes", label: "Ações", render: (fase) => {
            const acoes = fase.acoes || [];
            return acoes.length ? <MiniBar done={acoes.filter((a) => a.feito).length} total={acoes.length} width={70} /> : <span className="sub">—</span>;
          } },
          { key: "edit", label: "", align: "right", render: (fase) => (
            <span onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
              <Btn sm variant="ghost" onClick={() => setEditing(fase)}>Editar</Btn>
            </span>
          ) },
        ]}
        detail={(fase) => {
          const acoes = fase.acoes || [];
          return (
            <div className="detail-grid">
              <Detalhe label="Descrição" pre>{fase.descricao}</Detalhe>
              {acoes.length > 0 && (
                <div className="klist">
                  {acoes.map((a) => (
                    <div key={a.id} className={`klist-row${a.feito ? " done" : ""}`}>
                      <Check on={a.feito} onClick={() => toggleAcao(fase.id, a.id)} label={a.texto} />
                      <HoverInfo oque={a.oque} porque={a.porque}>
                        <span className="txt">{a.texto}</span>
                      </HoverInfo>
                      {a.responsavel && <span className="aside">{a.responsavel}</span>}
                    </div>
                  ))}
                </div>
              )}
              {!fase.descricao && acoes.length === 0 && <span className="sub">Sem descrição nem ações.</span>}
            </div>
          );
        }}
      />
      {showForm && <FaseModal onClose={() => setShowForm(false)} onSave={handleNew} />}
      {editing  && <FaseModal initial={editing} onClose={() => setEditing(null)} onSave={handleUpdate} onDelete={handleDelete} />}
    </div>
  );
}

// ── ClientDetail (exported) ───────────────────────────────────────────────────
export function ClientDetail({
  client, tasks, historico, criativos, concorrentes, analisesCliente,
  planos, metaAds, otimizacoes = [], anotacoes = [], socialPosts = [],
  onUpdateClient, onUpdateTask, onNewTask, onNewHistorico,
  onDeleteTask, onNewCriativo, onSaveCriativo, onUpdateCriativo, onEditClient,
  onNewAnalise, onUpdateAnalise, onDeleteAnalise,
  onNewPlano, onUpdatePlano, onDeletePlano,
  onNewMetaAds, onUpdateMetaAds, onDeleteMetaAds,
  onNewOtimizacao, onUpdateOtimizacao, onDeleteOtimizacao,
  onNewAnotacao, onDeleteAnotacao,
  onNewSocialPost, onUpdateSocialPost, onDeleteSocialPost,
}) {
  const [tab, setTab]               = useState("operacao");
  const [showVirada, setShowVirada]     = useState(false);
  const [showCopy, setShowCopy]         = useState(false);
  const [copyText, setCopyText]         = useState("");
  const [copyLoading, setCopyLoading]   = useState(false);
  const [showRelatorio, setShowRelatorio]   = useState(false);
  const [relatorioText, setRelatorioText]   = useState("");
  const [relatorioLoading, setRelatorioLoading] = useState(false);

  const stage = CYCLE.find((s) => s.id === client.cycle_stage) || CYCLE[5];
  const month = curMonth();

  const clientTasks = tasks.filter((t) => t.client_id === client.id);
  const monthTasks  = clientTasks.filter((t) => t.month === month && !t.archived);
  const done        = monthTasks.filter((t) => t.status === "Concluído").length;

  async function handleStageChange(newStage) {
    await onUpdateClient(client.id, { cycle_stage: newStage });
  }

  async function handleViradaMensal() {
    const next = nextMonthStr();
    for (const t of monthTasks) {
      const freshChecklist = (t.checklist || []).map((item) => ({ ...item, done: false }));
      await db("rc2_tasks", "POST", {
        client_id:   t.client_id,
        name:        t.name,
        type:        t.type,
        priority:    t.priority,
        status:      "A fazer",
        cycle_stage: t.cycle_stage,
        month:       next,
        checklist:   freshChecklist,
        history:     [],
        archived:    false,
      });
    }
    setShowVirada(false);
    window.location.reload();
  }

  const planoMes = planos.find((p) => p.month === month);
  const planoPct = planoMes && planoMes.items.length
    ? Math.round((planoMes.items.filter((i) => i.done).length / planoMes.items.length) * 100)
    : null;

  const smPendentes = socialPosts.filter((p) => p.status === "pendente").length;
  const smAtrasados = socialPosts.filter((p) => p.status === "pendente" && p.data_prevista < new Date().toISOString().split("T")[0]).length;

  const partesNome = (client.name || "").trim().split(/\s+/);
  const nomePartes = partesNome.length > 1
    ? { inicio: partesNome.slice(0, -1).join(" "), fim: partesNome[partesNome.length - 1] }
    : { inicio: "", fim: partesNome[0] || "" };

  const tabs = [
    { id: "operacao",     label: "Operação" },
    { id: "plano",        label: `Plano${planoPct !== null ? ` ${planoPct}%` : ""}` },
    { id: "otimizacoes",  label: `Otimizações${otimizacoes.length ? ` (${otimizacoes.length})` : ""}` },
    { id: "anotacoes",    label: `Anotações${anotacoes.length ? ` (${anotacoes.length})` : ""}` },
    { id: "analises",     label: `Análises${analisesCliente.length ? ` (${analisesCliente.length})` : ""}` },
    { id: "historico",    label: "Histórico" },
    { id: "social",       label: `Social Media${smAtrasados > 0 ? ` ⚠ ${smAtrasados}` : smPendentes > 0 ? ` (${smPendentes})` : ""}` },
    { id: "criativos",    label: "Criativos" },
    { id: "concorrentes", label: "Concorrentes" },
    { id: "metaads",      label: "Meta Ads" },
    { id: "tracking",     label: "Tracking" },
    { id: "estrategia",   label: "Estratégia" },
  ];

  return (
    <div className="view" style={{ maxWidth: 1120 }}>
      <Stage
        path={`clientes/${(client.name || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
        title={nomePartes.inicio}
        hl={nomePartes.fim}
        lead={
          <span style={{ display: "inline-flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <Selo tone="gold" dot={false}>{client.type}</Selo>
            {client.grupo && <Selo tone="off" dot={false}>{client.grupo}</Selo>}
            {client.specialty && <span>{client.specialty}</span>}
            {client.notes && <span>· {client.notes}</span>}
          </span>
        }
        actions={
          <>
            <Btn sm variant="secondary" onClick={onEditClient}>Editar</Btn>
            <Btn sm variant="primary" onClick={async () => {
              setShowCopy(true); setCopyText(""); setCopyLoading(true);
              try { setCopyText(await gerarCopy(client)); }
              catch (e) { setCopyText("Erro ao gerar: " + e.message); }
              finally { setCopyLoading(false); }
            }}>✦ Gerar Copy</Btn>
            <Btn sm variant="secondary" onClick={async () => {
              setShowRelatorio(true); setRelatorioText(""); setRelatorioLoading(true);
              try {
                setRelatorioText(await gerarRelatorio(client, {
                  tasks, otimizacoes, metaAds, analises: analisesCliente, mes: month,
                }));
              } catch (e) { setRelatorioText("Erro ao gerar: " + e.message); }
              finally { setRelatorioLoading(false); }
            }}>📋 Gerar Relatório</Btn>
            <Btn sm variant="secondary" onClick={() => setShowVirada(true)}>↻ Virada Mensal</Btn>
          </>
        }
        tabs={<StageTabs label="Seções do cliente" items={tabs} active={tab} onChange={setTab} />}
      />

      <KpiStrip style={{ marginBottom: 16 }} items={[
        { label: "Tarefas do mês", value: `${done}/${monthTasks.length}`, sub: month, tone: monthTasks.length && done === monthTasks.length ? "ok" : "" },
        { label: "Plano do mês", value: planoPct !== null ? `${planoPct}%` : "—", sub: planoPct === null ? "sem plano" : planoPct >= 50 ? "no ritmo" : "abaixo de 50%", tone: planoPct === null ? "warn" : planoPct >= 50 ? "ok" : "warn" },
        { label: "Orçamento", value: client.orcamento_total ? fmtCurr(client.orcamento_total) : "—", sub: client.orcamento_total ? `${fmtCurr((client.orcamento_total / 30).toFixed(2))}/dia` : "não informado" },
        { label: "Relatório", value: client.dia_relatorio ? `dia ${client.dia_relatorio}` : "—", sub: client.dia_relatorio ? "todo mês" : "sem dia definido", tone: client.dia_relatorio ? "" : "warn" },
      ]} />

      <Card style={{ padding: "14px 18px", marginBottom: 12 }}>
        <div className="eyebrow" style={{ marginBottom: 8 }}>Etapa do ciclo</div>
        <CycleBar stage={client.cycle_stage} onChange={handleStageChange} />
      </Card>

      {(client.orcamento_total || client.cidades || client.dia_relatorio || client.cliente_envia_criativos || client.site || client.whatsapp || client.publico_alvo || client.dores || client.objecoes || client.solucao || client.transformacao || client.estrategias_utilizadas || client.convenios_atende || client.convenios_nao_atende) && (
      <div style={{ marginBottom: 20 }}>
        <Explica title="Dados do cliente: orçamento, contatos, persona e funil">
          {(client.orcamento_total || client.cidades || client.dia_relatorio || client.cliente_envia_criativos || client.site || client.whatsapp || client.publico_alvo || client.dores || client.objecoes || client.solucao || client.transformacao || client.estrategias_utilizadas || client.convenios_atende || client.convenios_nao_atende) && (
              <div style={{ display: "flex", flexDirection: "column", gap: 14, color: "var(--ink)" }}>
                {client.updated_at && (
                  <div style={{ fontSize: 11, color: "var(--muted)" }}>
                    Atualizado em {new Date(client.updated_at).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "America/Sao_Paulo" })}
                  </div>
                )}

                {/* Linha 1 — métricas e operacional */}
                <div style={{ display: "flex", gap: 24, flexWrap: "wrap", alignItems: "flex-start" }}>
                  {client.orcamento_total && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>Orçamento Total</div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
                        {fmtCurr(client.orcamento_total)}<span style={{ fontWeight: 400, color: "var(--muted)", fontSize: 12 }}>/mês</span>
                        <span style={{ color: "var(--line)", margin: "0 5px" }}>·</span>
                        {fmtCurr((client.orcamento_total / 30).toFixed(2))}<span style={{ fontWeight: 400, color: "var(--muted)", fontSize: 12 }}>/dia</span>
                      </div>
                      {(client.orcamento_meta || client.orcamento_google) && (
                        <div style={{ display: "flex", gap: 12, marginTop: 5, flexWrap: "wrap" }}>
                          {client.orcamento_meta && (
                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                              <span style={{ fontSize: 10, background: "var(--primary-soft)", color: "var(--primary)", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>Meta</span>
                              <span style={{ fontSize: 12, fontWeight: 600, color: "var(--ink)" }}>{fmtCurr(client.orcamento_meta)}</span>
                            </div>
                          )}
                          {client.orcamento_google && (
                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                              <span style={{ fontSize: 10, background: "var(--danger-soft)", color: "var(--danger-ink)", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>Google</span>
                              <span style={{ fontSize: 12, fontWeight: 600, color: "var(--ink)" }}>{fmtCurr(client.orcamento_google)}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {client.cidades && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>Cidades</div>
                      <div style={{ fontSize: 13, color: "var(--ink)", lineHeight: 1.7 }}>
                        {client.cidades.split(/[,\n]/).map((c) => c.trim()).filter(Boolean).map((c, i) => (
                          <div key={i}>{c}</div>
                        ))}
                      </div>
                    </div>
                  )}
                  {client.dia_relatorio && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>Relatório</div>
                      <div style={{ fontSize: 13, color: "var(--ink)" }}>Dia {client.dia_relatorio}</div>
                    </div>
                  )}
                  {client.cliente_envia_criativos && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>Criativos</div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "var(--success-ink)" }}>Cliente envia</div>
                    </div>
                  )}
                  {client.site && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>Site</div>
                      <a href={client.site} target="_blank" rel="noopener noreferrer" style={{ fontSize: 13, color: "var(--primary)", textDecoration: "none" }}>
                        {client.site.replace(/^https?:\/\//, "")}
                      </a>
                    </div>
                  )}
                  {client.whatsapp && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>WhatsApp</div>
                      <div style={{ fontSize: 13, color: "var(--ink)" }}>{client.whatsapp}</div>
                    </div>
                  )}
                  {client.whatsapp_secretaria && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>Secretária</div>
                      <div style={{ fontSize: 13, color: "var(--ink)" }}>{client.whatsapp_secretaria}</div>
                    </div>
                  )}
                </div>

                {/* Linha 2 — Persona: label em cima, texto abaixo (mais espaço de leitura) */}
                {(client.publico_alvo || client.dores || client.objecoes || client.solucao || client.transformacao) && (
                  <div style={{ background: "var(--bg)", borderRadius: 8, padding: "14px 18px" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 12 }}>Persona</div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "12px 24px" }}>
                      {[
                        { label: "Público",       value: client.publico_alvo },
                        { label: "Dores",         value: client.dores },
                        { label: "Objeções",      value: client.objecoes },
                        { label: "Solução",       value: client.solucao },
                        { label: "Transformação", value: client.transformacao },
                      ].filter((r) => r.value).map((r) => (
                        <div key={r.label}>
                          <div style={{ fontSize: 10, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".04em", marginBottom: 4 }}>{r.label}</div>
                          <div style={{ fontSize: 12, color: "var(--ink)", lineHeight: 1.65 }}>{r.value}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Convênios do médico: mesma lista da Ficha do cliente no Dash (o Dash grava aqui ao salvar a ficha) */}
                {(client.convenios_atende || client.convenios_nao_atende) && (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 12 }}>
                    {[
                      { label: "Convênios que atende", value: client.convenios_atende, bg: "var(--success-soft)", ink: "var(--success-ink)" },
                      { label: "Não atende · nunca em anúncio", value: client.convenios_nao_atende, bg: "var(--danger-soft)", ink: "var(--danger-ink)" },
                    ].filter((r) => r.value).map((r) => (
                      <div key={r.label} style={{ background: r.bg, borderRadius: 8, padding: "12px 16px" }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: r.ink, textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 6 }}>{r.label}</div>
                        <div style={{ fontSize: 12, color: "var(--ink)", lineHeight: 1.7 }}>{r.value.split(/\n+/).map((x) => x.trim()).filter(Boolean).join(" · ")}</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Linha 3 — Estratégias */}
                {client.estrategias_utilizadas && (
                  <div style={{ background: "var(--warn-soft)", borderRadius: 8, padding: "12px 16px" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "var(--warn-ink)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 6 }}>Estratégias já utilizadas</div>
                    <div style={{ fontSize: 12, color: "var(--warn-ink)", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{client.estrategias_utilizadas}</div>
                  </div>
                )}

                {/* Linha 4 — Funil de Marketing */}
                {(client.funil_topo || client.funil_meio || client.funil_fundo) &&
                 [client.funil_topo, client.funil_meio, client.funil_fundo].some(f => f && Object.values(f).some(v => v)) && (
                  <div style={{ background: "var(--bg)", borderRadius: 8, padding: "14px 18px" }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 12 }}>Funil de Marketing</div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
                      {[
                        { key: "funil_topo",  label: "🔝 Topo — Consciência",  sub: "Audiência fria", accent: "var(--primary-soft)", ink: "var(--primary)" },
                        { key: "funil_meio",  label: "🔄 Meio — Consideração", sub: "Audiência morna",  accent: "var(--warn-soft)",    ink: "var(--warn-ink)" },
                        { key: "funil_fundo", label: "🎯 Fundo — Decisão",     sub: "Audiência quente", accent: "var(--success-soft)", ink: "var(--success-ink)" },
                      ].map(({ key, label, sub, accent, ink }) => {
                        const fu = client[key] || {};
                        if (!Object.values(fu).some(v => v)) return null;
                        return (
                          <div key={key} style={{ background: accent, borderRadius: 8, padding: "12px 14px" }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: ink, marginBottom: 2 }}>{label}</div>
                            <div style={{ fontSize: 10, color: ink, opacity: .7, marginBottom: 10 }}>{sub}</div>
                            {fu.objetivo && (
                              <div style={{ marginBottom: 8 }}>
                                <div style={{ fontSize: 9, fontWeight: 700, color: ink, opacity: .7, textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 2 }}>Objetivo</div>
                                <div style={{ fontSize: 12, color: "var(--ink)", lineHeight: 1.5 }}>{fu.objetivo}</div>
                              </div>
                            )}
                            {fu.publico && (
                              <div style={{ marginBottom: 8 }}>
                                <div style={{ fontSize: 9, fontWeight: 700, color: ink, opacity: .7, textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 2 }}>Público</div>
                                <div style={{ fontSize: 12, color: "var(--ink)", lineHeight: 1.5 }}>{fu.publico}</div>
                              </div>
                            )}
                            {fu.criativos && (
                              <div>
                                <div style={{ fontSize: 9, fontWeight: 700, color: ink, opacity: .7, textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 4 }}>Criativos</div>
                                <div style={{ fontSize: 12, color: "var(--ink)", lineHeight: 1.7, whiteSpace: "pre-wrap", fontFamily: "var(--font-data)" }}>{fu.criativos}</div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
        </Explica>
      </div>
      )}
      <div key={client.id} style={{ paddingTop: 8 }}>
        {tab === "operacao"     && <OperacaoTab client={client} tasks={monthTasks} onNewTask={onNewTask} onUpdateTask={onUpdateTask} onDeleteTask={onDeleteTask} planos={planos} onUpdatePlano={onUpdatePlano} />}
        {tab === "plano"        && <PlanoTab client={client} planos={planos} onNewPlano={onNewPlano} onUpdatePlano={onUpdatePlano} onDeletePlano={onDeletePlano} />}
        {tab === "otimizacoes"  && <OtimizacoesTab client={client} otimizacoes={otimizacoes} tasks={tasks} onNew={onNewOtimizacao} onUpdate={onUpdateOtimizacao} onDelete={onDeleteOtimizacao} />}
        {tab === "anotacoes"    && <AnotacoesTab client={client} anotacoes={anotacoes} onNew={onNewAnotacao} onDelete={onDeleteAnotacao} />}
        {tab === "analises"     && <AnalisesClienteTab client={client} analises={analisesCliente} onNew={onNewAnalise} onUpdate={onUpdateAnalise} onDelete={onDeleteAnalise} />}
        {tab === "historico"    && <HistoricoTab client={client} historico={historico} onNewHistorico={onNewHistorico} />}
        {tab === "social"       && <SocialMediaClienteTab posts={socialPosts} client={client} onNew={onNewSocialPost} onUpdate={onUpdateSocialPost} onDelete={onDeleteSocialPost} />}
        {tab === "criativos"    && <CriativosClienteTab criativos={criativos} client={client} onNewCriativo={onNewCriativo} onSaveCriativo={onSaveCriativo} onUpdateCriativo={onUpdateCriativo} />}
        {tab === "concorrentes" && <ConcorrentesClienteTab concorrentes={concorrentes} clientId={client.id} />}
        {tab === "metaads"      && <MetaAdsTab client={client} metaAds={metaAds} onNew={onNewMetaAds} onUpdate={onUpdateMetaAds} onDelete={onDeleteMetaAds} />}
        {tab === "tracking"     && <TrackingTab client={client} onUpdateClient={onUpdateClient} />}
        {tab === "estrategia"   && <EstrategiaTab client={client} />}
      </div>

      {showCopy && (
        <Modal title={`Copy — ${client.name}`} subtitle="Gerado por Claude AI" onClose={() => setShowCopy(false)} width={620}>
          {copyLoading ? (
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "20px 0" }}>
              <Spinner size={20} /><span style={{ fontSize: 13, color: "var(--muted)" }}>Gerando copies com IA...</span>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {copyText.split(/VARIAÇÃO \d+/).filter(Boolean).map((v, i) => (
                <Card key={i} style={{ padding: "14px 18px", background: "var(--bg)" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--primary)" }}>VARIAÇÃO {i + 1}</div>
                    <Btn sm variant="ghost" onClick={() => navigator.clipboard.writeText(v.trim())}>Copiar</Btn>
                  </div>
                  <div style={{ fontSize: 13, color: "var(--ink)", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{v.trim()}</div>
                </Card>
              ))}
              <Btn variant="accent" full onClick={async () => {
                setCopyText(""); setCopyLoading(true);
                try { setCopyText(await gerarCopy(client)); }
                catch (e) { setCopyText("Erro: " + e.message); }
                finally { setCopyLoading(false); }
              }}>↻ Gerar novas variações</Btn>
            </div>
          )}
        </Modal>
      )}

      {showRelatorio && (
        <Modal title={`Relatório Mensal — ${client.name}`} subtitle={`${month} · Gerado por IA`} onClose={() => setShowRelatorio(false)} width={680}>
          {relatorioLoading ? (
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "24px 0" }}>
              <Spinner size={20} />
              <span style={{ fontSize: 13, color: "var(--muted)" }}>Analisando ações do mês e gerando relatório...</span>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{
                fontSize: 13, color: "var(--ink)", lineHeight: 1.8,
                whiteSpace: "pre-wrap", background: "var(--bg)",
                borderRadius: 8, padding: "16px 20px",
                maxHeight: 480, overflowY: "auto",
              }}>
                {relatorioText}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Btn variant="accent" onClick={() => navigator.clipboard.writeText(relatorioText)}>
                  Copiar relatório
                </Btn>
                <Btn variant="secondary" onClick={async () => {
                  setRelatorioText(""); setRelatorioLoading(true);
                  try {
                    setRelatorioText(await gerarRelatorio(client, {
                      tasks, otimizacoes, metaAds, analises: analisesCliente, mes: month,
                    }));
                  } catch (e) { setRelatorioText("Erro: " + e.message); }
                  finally { setRelatorioLoading(false); }
                }}>↻ Regenerar</Btn>
              </div>
            </div>
          )}
        </Modal>
      )}

      {showVirada && (
        <Modal title="Virada Mensal" subtitle={`Criar tarefas de ${nextMonthStr()} com checklist zerado`} onClose={() => setShowVirada(false)} width={420}>
          <div style={{ fontSize: 13, color: "var(--muted)", marginBottom: 20 }}>
            Serão criadas <strong>{monthTasks.length} tarefas</strong> para <strong>{nextMonthStr()}</strong> com o checklist resetado. O histórico de otimizações não é copiado.
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="secondary" onClick={() => setShowVirada(false)} full>Cancelar</Btn>
            <Btn variant="accent"    onClick={handleViradaMensal} full>Confirmar virada</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}
